var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2Ta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 226.402,
    height: 273.367,
    viewBox: "0 0 226.402 273.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25554",
    "data-name": "Rectangle 25554",
    width: 223.378,
    height: 198.824,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25539",
    "data-name": "Rectangle 25539",
    width: 45.483,
    height: 63.14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25549",
    "data-name": "Rectangle 25549",
    width: 19.319,
    height: 18.464,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25550",
    "data-name": "Rectangle 25550",
    width: 21.739,
    height: 22.486,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25551",
    "data-name": "Rectangle 25551",
    width: 25.023,
    height: 25.477,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87920",
    "data-name": "Group 87920",
    transform: "translate(-15240 -19759.957)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4987",
    "data-name": "Ellipse 4987",
    cx: 113.201,
    cy: 113.201,
    r: 113.201,
    transform: "translate(15240 19759.957)",
    fill: "#f9f3f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87818",
    "data-name": "Group 87818",
    transform: "translate(15337 19782.361)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_24009",
    "data-name": "Rectangle 24009",
    width: 32.882,
    height: 42.174,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203106",
    "data-name": "Path 203106",
    d: "M14.7,2.96l.159.1c.268.774.606,2.005.953,3.306v.208l-.884.069Z",
    transform: "translate(-0.106 -0.021)",
    fill: "#ffa900"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87897",
    "data-name": "Group 87897",
    transform: "translate(15242 19834.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87914",
    "data-name": "Group 87914",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87913",
    "data-name": "Group 87913",
    transform: "translate(2.696 16.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87915",
    "data-name": "Group 87915"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276419",
    "data-name": "Path 276419",
    d: "M47.668,42.632a.241.241,0,0,1-.241-.241V13.973a.241.241,0,0,1,.481,0V42.391a.241.241,0,0,1-.241.241",
    transform: "translate(16.601 -11.296)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276420",
    "data-name": "Path 276420",
    d: "M47.668,175.83a.241.241,0,0,1-.241-.241V36.183a.241.241,0,0,1,.481,0V175.589a.241.241,0,0,1-.241.241",
    transform: "translate(16.601 -2.26)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25519",
    "data-name": "Rectangle 25519",
    width: 4.356,
    height: 19.312,
    transform: "translate(72.032 6.033)",
    fill: "#fed5a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276421",
    "data-name": "Path 276421",
    d: "M57.543,35.91H53.186a.241.241,0,0,1-.241-.241V16.359a.241.241,0,0,1,.241-.241h4.357a.242.242,0,0,1,.241.241V35.669a.242.242,0,0,1-.241.241m-4.117-.481H57.3V16.6H53.426Z",
    transform: "translate(18.846 -10.325)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25520",
    "data-name": "Rectangle 25520",
    width: 4.356,
    height: 1.888,
    transform: "translate(72.032 8.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276422",
    "data-name": "Path 276422",
    d: "M57.543,20.551H53.186a.241.241,0,0,1-.241-.241V18.423a.241.241,0,0,1,.241-.241h4.357a.242.242,0,0,1,.241.241v1.888a.242.242,0,0,1-.241.241m-4.117-.481H57.3V18.665H53.426Z",
    transform: "translate(18.846 -9.486)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25521",
    "data-name": "Rectangle 25521",
    width: 4.356,
    height: 1.888,
    transform: "translate(72.032 20.916)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276423",
    "data-name": "Path 276423",
    d: "M57.543,29.066H53.186a.241.241,0,0,1-.241-.241V26.939a.241.241,0,0,1,.241-.241h4.357a.242.242,0,0,1,.241.241v1.887a.242.242,0,0,1-.241.241m-4.117-.481H57.3V27.179H53.426Z",
    transform: "translate(18.846 -6.021)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25522",
    "data-name": "Rectangle 25522",
    width: 6.099,
    height: 19.312,
    transform: "translate(75.37 6.033)",
    fill: "#fda12c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276424",
    "data-name": "Path 276424",
    d: "M61.656,35.91h-6.1a.242.242,0,0,1-.241-.241V16.359a.242.242,0,0,1,.241-.241h6.1a.241.241,0,0,1,.241.241V35.669a.241.241,0,0,1-.241.241M55.8,35.429h5.615V16.6H55.8Z",
    transform: "translate(19.811 -10.325)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25523",
    "data-name": "Rectangle 25523",
    width: 4.356,
    height: 19.312,
    transform: "translate(76.677 6.033)",
    fill: "#fed5a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276425",
    "data-name": "Path 276425",
    d: "M60.844,35.91H56.487a.241.241,0,0,1-.241-.241V16.359a.241.241,0,0,1,.241-.241h4.357a.241.241,0,0,1,.241.241V35.669a.241.241,0,0,1-.241.241m-4.116-.481H60.6V16.6H56.727Z",
    transform: "translate(20.189 -10.325)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25524",
    "data-name": "Rectangle 25524",
    width: 4.356,
    height: 1.888,
    transform: "translate(76.677 8.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276426",
    "data-name": "Path 276426",
    d: "M60.844,20.551H56.487a.241.241,0,0,1-.241-.241V18.423a.241.241,0,0,1,.241-.241h4.357a.241.241,0,0,1,.241.241v1.888a.241.241,0,0,1-.241.241m-4.116-.481H60.6V18.665H56.727Z",
    transform: "translate(20.189 -9.486)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25525",
    "data-name": "Rectangle 25525",
    width: 4.356,
    height: 1.888,
    transform: "translate(76.677 20.916)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276427",
    "data-name": "Path 276427",
    d: "M60.844,29.066H56.487a.241.241,0,0,1-.241-.241V26.939a.241.241,0,0,1,.241-.241h4.357a.241.241,0,0,1,.241.241v1.887a.241.241,0,0,1-.241.241m-4.116-.481H60.6V27.179H56.727Z",
    transform: "translate(20.189 -6.021)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25526",
    "data-name": "Rectangle 25526",
    width: 6.099,
    height: 19.312,
    transform: "translate(80.016 6.033)",
    fill: "#fda12c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276428",
    "data-name": "Path 276428",
    d: "M64.961,35.91h-6.1a.241.241,0,0,1-.241-.241V16.359a.241.241,0,0,1,.241-.241h6.1a.241.241,0,0,1,.241.241V35.669a.241.241,0,0,1-.241.241m-5.86-.481H64.72V16.6H59.1Z",
    transform: "translate(21.155 -10.325)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25527",
    "data-name": "Rectangle 25527",
    width: 4.356,
    height: 19.312,
    transform: "translate(81.324 6.033)",
    fill: "#fed5a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276429",
    "data-name": "Path 276429",
    d: "M64.148,35.91H59.791a.241.241,0,0,1-.241-.241V16.359a.241.241,0,0,1,.241-.241h4.357a.241.241,0,0,1,.241.241V35.669a.241.241,0,0,1-.241.241m-4.116-.481h3.876V16.6H60.031Z",
    transform: "translate(21.533 -10.325)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25528",
    "data-name": "Rectangle 25528",
    width: 4.356,
    height: 1.888,
    transform: "translate(81.324 8.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276430",
    "data-name": "Path 276430",
    d: "M64.148,20.551H59.791a.241.241,0,0,1-.241-.241V18.423a.241.241,0,0,1,.241-.241h4.357a.241.241,0,0,1,.241.241v1.888a.241.241,0,0,1-.241.241m-4.116-.481h3.876V18.665H60.031Z",
    transform: "translate(21.533 -9.486)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25529",
    "data-name": "Rectangle 25529",
    width: 4.356,
    height: 1.888,
    transform: "translate(81.324 20.916)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276431",
    "data-name": "Path 276431",
    d: "M64.148,29.066H59.791a.241.241,0,0,1-.241-.241V26.939a.241.241,0,0,1,.241-.241h4.357a.241.241,0,0,1,.241.241v1.887a.241.241,0,0,1-.241.241m-4.116-.481h3.876V27.179H60.031Z",
    transform: "translate(21.533 -6.021)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25530",
    "data-name": "Rectangle 25530",
    width: 6.099,
    height: 19.312,
    transform: "translate(84.662 6.033)",
    fill: "#fed5a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276432",
    "data-name": "Path 276432",
    d: "M68.261,35.91h-6.1a.241.241,0,0,1-.241-.241V16.359a.241.241,0,0,1,.241-.241h6.1a.241.241,0,0,1,.241.241V35.669a.241.241,0,0,1-.241.241m-5.855-.481H68.02V16.6H62.405Z",
    transform: "translate(22.499 -10.325)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276433",
    "data-name": "Path 276433",
    d: "M69.254,30.865H79.487L82.211,28.4H69.254Z",
    transform: "translate(25.481 -5.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276434",
    "data-name": "Path 276434",
    d: "M79.557,31.174H69.325a.241.241,0,0,1-.241-.241V28.476a.241.241,0,0,1,.241-.241H82.279a.241.241,0,0,1,.163.419L79.72,31.112a.253.253,0,0,1-.163.062m-9.992-.481h9.9l2.19-1.977H69.565Z",
    transform: "translate(25.412 -5.395)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276435",
    "data-name": "Path 276435",
    d: "M81.112,30.413l-.325-.561L69.1,29.827l.339.587Z",
    transform: "translate(25.42 -4.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276436",
    "data-name": "Path 276436",
    d: "M81.181,30.724H69.512a.241.241,0,0,1-.207-.12l-.345-.587a.238.238,0,0,1,0-.241.242.242,0,0,1,.21-.121l11.688.024a.244.244,0,0,1,.21.12l.322.564a.238.238,0,0,1,0,.241.249.249,0,0,1-.21.12m-11.529-.481H80.765l-.046-.082-11.13-.024Z",
    transform: "translate(25.349 -4.817)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25531",
    "data-name": "Rectangle 25531",
    width: 4.356,
    height: 19.312,
    transform: "translate(85.039 8.611) rotate(-30.043)",
    fill: "#fed5a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276437",
    "data-name": "Path 276437",
    d: "M72.1,35.78a.323.323,0,0,1-.063-.007.244.244,0,0,1-.146-.113L62.222,18.942a.243.243,0,0,1,.09-.331l3.77-2.182a.272.272,0,0,1,.183-.023.251.251,0,0,1,.148.113l9.665,16.718a.241.241,0,0,1-.09.329l-3.77,2.182a.248.248,0,0,1-.12.031M62.763,18.911l9.425,16.3,3.351-1.941-9.425-16.3Z",
    transform: "translate(22.608 -10.211)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25532",
    "data-name": "Rectangle 25532",
    width: 4.356,
    height: 1.887,
    transform: "translate(86.493 11.125) rotate(-30.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276438",
    "data-name": "Path 276438",
    d: "M64.408,22.482a.312.312,0,0,1-.062-.008.251.251,0,0,1-.148-.113l-.944-1.635a.242.242,0,0,1,.09-.331l3.77-2.178a.253.253,0,0,1,.331.089l.947,1.632a.242.242,0,0,1-.089.329l-3.775,2.183a.286.286,0,0,1-.121.031M63.795,20.7l.7,1.216,3.354-1.941-.706-1.211Z",
    transform: "translate(23.027 -9.482)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25533",
    "data-name": "Rectangle 25533",
    width: 4.356,
    height: 1.887,
    transform: "translate(92.49 21.495) rotate(-30.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276439",
    "data-name": "Path 276439",
    d: "M68.674,29.851a.243.243,0,0,1-.21-.121L67.516,28.1a.245.245,0,0,1,.09-.331l3.77-2.182a.252.252,0,0,1,.331.09l.947,1.635a.242.242,0,0,1-.089.329L68.793,29.82a.257.257,0,0,1-.12.031m-.618-1.782.706,1.211,3.351-1.937-.706-1.216Z",
    transform: "translate(24.762 -6.484)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276440",
    "data-name": "Path 276440",
    d: "M83.884,33.366l-9.247-.025L64.969,16.623l9.247.025Z",
    transform: "translate(23.738 -10.12)",
    fill: "#fed5a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276441",
    "data-name": "Path 276441",
    d: "M83.953,33.678h0l-9.246-.028a.244.244,0,0,1-.21-.12L64.828,16.813a.238.238,0,0,1,0-.241.242.242,0,0,1,.21-.121l9.25.027a.249.249,0,0,1,.21.121l9.665,16.718a.244.244,0,0,1,0,.241.249.249,0,0,1-.21.121m-9.107-.509,8.687.027L74.148,16.96l-8.69-.028Z",
    transform: "translate(23.668 -10.19)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276442",
    "data-name": "Path 276442",
    d: "M82.855,27.692s-1.684-.6-2.164-3.247-1.322-6.372-.362-7.213,2.766-1.324,3.006.36-.121,4.93.241,5.651,1.563.241,1.563-1.2c0-2.376-.976-4.807-.619-7.233.492-3.326,3.848-3.69,4.209-.018.2,2.039.257,4.121.257,6.169,0,.841,1.442,1.322,1.322-.722-.086-1.46.962-3.126,2.4-2.645s.241,6.853-.241,7.936-3.486,1.322-3.486,1.322v2.764l-3.607.121-.121-2.766a5.436,5.436,0,0,1-2.4.722",
    transform: "translate(29.809 -11.93)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276443",
    "data-name": "Path 276443",
    d: "M85.45,30.048a.243.243,0,0,1-.242-.229l-.1-2.389A5.262,5.262,0,0,1,82.925,28a.215.215,0,0,1-.082-.015c-.073-.024-1.82-.675-2.321-3.429l-.167-.9c-.505-2.672-1.075-5.7-.117-6.539a2.8,2.8,0,0,1,2.521-.734,1.4,1.4,0,0,1,.881,1.242,21.233,21.233,0,0,1,.082,2.94,9.925,9.925,0,0,0,.136,2.636.326.326,0,0,0,.4.187c.353-.082.706-.549.706-1.282a18.078,18.078,0,0,0-.342-2.978,13.486,13.486,0,0,1-.272-4.288c.291-1.988,1.522-2.893,2.508-2.842.874.02,1.974.777,2.175,2.835.179,1.8.26,3.766.26,6.193a.5.5,0,0,0,.256.435.293.293,0,0,0,.3,0c.079-.046.331-.28.28-1.145a3.153,3.153,0,0,1,1.083-2.61,1.684,1.684,0,0,1,1.639-.28,1,1,0,0,1,.578.6c.765,1.719-.26,6.733-.671,7.665-.463,1.037-2.711,1.363-3.468,1.445v2.548a.244.244,0,0,1-.234.241l-3.607.121ZM85.329,26.8a.23.23,0,0,1,.113.031.236.236,0,0,1,.128.2l.108,2.528,3.139-.106V26.922a.245.245,0,0,1,.221-.242c.8-.062,2.94-.4,3.285-1.18.439-.99,1.332-5.8.675-7.276a.538.538,0,0,0-.291-.331,1.2,1.2,0,0,0-1.2.2,2.693,2.693,0,0,0-.893,2.2c.059,1.009-.241,1.417-.5,1.584a.782.782,0,0,1-.792.008.985.985,0,0,1-.505-.855,61.254,61.254,0,0,0-.26-6.147c-.172-1.745-.995-2.385-1.705-2.4h-.031c-.792,0-1.743.753-1.992,2.431a13.27,13.27,0,0,0,.272,4.136,18.4,18.4,0,0,1,.35,3.06,1.671,1.671,0,0,1-1.076,1.75.823.823,0,0,1-.944-.438,8.885,8.885,0,0,1-.19-2.863,21.429,21.429,0,0,0-.073-2.862.974.974,0,0,0-.575-.862,2.39,2.39,0,0,0-2.034.649c-.754.657-.16,3.794.272,6.089l.167.9a3.824,3.824,0,0,0,1.977,3.049,5.33,5.33,0,0,0,2.233-.684.233.233,0,0,1,.124-.035",
    transform: "translate(29.74 -12.001)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276444",
    "data-name": "Path 276444",
    d: "M84.45,20.751a.244.244,0,0,1-.241-.221s-.031-.381-.075-.986a.248.248,0,0,1,.227-.257h.015a.245.245,0,0,1,.241.225c.042.6.073.979.073.979a.242.242,0,0,1-.221.26Z",
    transform: "translate(31.536 -9.036)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276445",
    "data-name": "Path 276445",
    d: "M84.415,21.129a.244.244,0,0,1-.241-.225c-.174-2.458-.338-4.862-.377-5.8a2.708,2.708,0,0,1,.838-2.4.241.241,0,0,1,.276.4,2.292,2.292,0,0,0-.633,1.992c.044,1.057.269,4.253.377,5.786a.244.244,0,0,1-.225.256Z",
    transform: "translate(31.397 -11.733)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276446",
    "data-name": "Path 276446",
    d: "M85.634,21.2a.244.244,0,0,1-.241-.234l-.124-4.026a.242.242,0,0,1,.232-.249h.008a.244.244,0,0,1,.241.234l.124,4.026a.242.242,0,0,1-.232.249Z",
    transform: "translate(31.998 -10.093)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276447",
    "data-name": "Path 276447",
    d: "M86.162,21.962a.241.241,0,1,1,0-.481,5.625,5.625,0,0,0,.8-.07.139.139,0,0,1,.039,0,.241.241,0,0,1,.039.478,6.064,6.064,0,0,1-.882.077",
    transform: "translate(32.263 -8.174)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276448",
    "data-name": "Path 276448",
    d: "M87.471,23.566a.247.247,0,0,1-.218-.139.238.238,0,0,1,.117-.319,1.206,1.206,0,0,0,.45-.322c.514-.609.5-2.983.5-4v-.241a3.9,3.9,0,0,1,.461-1.826.229.229,0,0,1,.326-.084.239.239,0,0,1,.09.326,3.478,3.478,0,0,0-.4,1.584v.236c.008,1.853-.062,3.655-.606,4.311a1.742,1.742,0,0,1-.62.446.242.242,0,0,1-.1.024",
    transform: "translate(32.795 -10.128)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276449",
    "data-name": "Path 276449",
    d: "M83.213,23.229a1.99,1.99,0,0,1-1.246-.443,3.864,3.864,0,0,1-1.079-2.03.233.233,0,0,1,.163-.3.245.245,0,0,1,.294.163,3.592,3.592,0,0,0,.917,1.783,1.54,1.54,0,0,0,1.844.062.232.232,0,0,1,.333.046.236.236,0,0,1-.042.333,2.049,2.049,0,0,1-1.185.381",
    transform: "translate(30.21 -8.563)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276450",
    "data-name": "Path 276450",
    d: "M81.075,21.484a.24.24,0,0,1-.236-.19c-.117-.567-.222-1.154-.319-1.714-.084-.473-.163-.923-.248-1.335a2.41,2.41,0,0,1,.245-2.019,1.079,1.079,0,0,1,.784-.4.241.241,0,0,1,.241.241.238.238,0,0,1-.236.241.6.6,0,0,0-.423.232c-.167.214-.326.664-.136,1.616.082.411.163.869.249,1.344.1.554.2,1.138.318,1.7a.242.242,0,0,1-.186.287.223.223,0,0,1-.051,0",
    transform: "translate(29.926 -10.445)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276451",
    "data-name": "Path 276451",
    d: "M84.541,24.691a.24.24,0,0,1-.241-.218l-.245-2.621a.245.245,0,0,1,.218-.263H84.3a.24.24,0,0,1,.241.217l.245,2.621a.246.246,0,0,1-.217.264Z",
    transform: "translate(31.503 -8.099)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276452",
    "data-name": "Path 276452",
    d: "M91.792,23.8l-.438,3.588-.3,2.444-.346,2.842H82.058l-.346-2.842-.3-2.444L80.976,23.8Z",
    transform: "translate(30.251 -7.199)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276453",
    "data-name": "Path 276453",
    d: "M90.78,32.985H82.128a.236.236,0,0,1-.236-.214L80.808,23.9a.223.223,0,0,1,.058-.19.233.233,0,0,1,.179-.082H91.863a.233.233,0,0,1,.179.082.223.223,0,0,1,.058.19l-1.083,8.869a.235.235,0,0,1-.236.214M82.341,32.5h8.225l1.026-8.392H81.316Z",
    transform: "translate(30.181 -7.269)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276454",
    "data-name": "Path 276454",
    d: "M91.228,26.353l-.3,2.444H81.585l-.3-2.444Z",
    transform: "translate(30.377 -6.161)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276455",
    "data-name": "Path 276455",
    d: "M91,29.105H81.655a.235.235,0,0,1-.236-.21l-.3-2.442a.228.228,0,0,1,.059-.19.233.233,0,0,1,.179-.082H91.3a.236.236,0,0,1,.179.082.223.223,0,0,1,.058.19l-.3,2.442a.237.237,0,0,1-.238.21m-9.129-.481h8.917l.241-1.961h-9.4Z",
    transform: "translate(30.308 -6.231)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25534",
    "data-name": "Rectangle 25534",
    width: 55.535,
    height: 3.678,
    transform: "translate(71.259 25.479)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276456",
    "data-name": "Path 276456",
    d: "M108.172,34.1H52.636a.242.242,0,0,1-.241-.241V30.182a.242.242,0,0,1,.241-.241h55.536a.242.242,0,0,1,.241.241v3.678a.242.242,0,0,1-.241.241m-55.294-.481h55.053v-3.2H52.878Z",
    transform: "translate(18.622 -4.701)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25535",
    "data-name": "Rectangle 25535",
    width: 12.802,
    height: 3.678,
    transform: "translate(113.991 25.479)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276457",
    "data-name": "Path 276457",
    d: "M95.813,34.1H83.01a.241.241,0,0,1-.241-.241V30.182a.241.241,0,0,1,.241-.241h12.8a.242.242,0,0,1,.241.241v3.678a.242.242,0,0,1-.241.241M83.25,33.619H95.572v-3.2H83.25Z",
    transform: "translate(30.98 -4.701)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276458",
    "data-name": "Path 276458",
    d: "M82.056,32.735c5.948,2.2,4.875,6.339,4.875,6.339h5.636V32.735Z",
    transform: "translate(30.69 -3.564)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276459",
    "data-name": "Path 276459",
    d: "M92.635,39.386H87a.247.247,0,0,1-.191-.093.231.231,0,0,1-.042-.205c.042-.163.936-3.965-4.723-6.058a.238.238,0,0,1-.155-.269.241.241,0,0,1,.236-.2H92.635a.242.242,0,0,1,.241.241v6.341a.242.242,0,0,1-.241.241M87.283,38.9h5.11v-5.86H83.314c4.05,1.946,4.074,4.913,3.969,5.86",
    transform: "translate(30.621 -3.634)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276460",
    "data-name": "Path 276460",
    d: "M83.405,32.735c5.948,2.2,4.875,6.339,4.875,6.339h5.636V32.735Z",
    transform: "translate(31.239 -3.564)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276461",
    "data-name": "Path 276461",
    d: "M93.986,39.386H88.35a.246.246,0,0,1-.19-.093.231.231,0,0,1-.042-.205c.038-.163.931-3.965-4.726-6.058a.239.239,0,0,1-.156-.269.242.242,0,0,1,.238-.2H93.986a.242.242,0,0,1,.241.241v6.341a.242.242,0,0,1-.241.241M88.634,38.9h5.11v-5.86H84.661c4.05,1.946,4.079,4.913,3.973,5.86",
    transform: "translate(31.169 -3.634)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276462",
    "data-name": "Path 276462",
    d: "M54.964,32.735c5.948,2.2,4.875,6.339,4.875,6.339h5.636V32.735Z",
    transform: "translate(19.667 -3.564)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276463",
    "data-name": "Path 276463",
    d: "M65.545,39.386H59.91a.247.247,0,0,1-.191-.093.231.231,0,0,1-.042-.205c.038-.163.931-3.965-4.726-6.058a.239.239,0,0,1-.156-.269.242.242,0,0,1,.238-.2H65.545a.242.242,0,0,1,.241.241v6.341a.242.242,0,0,1-.241.241M60.193,38.9H65.3v-5.86H56.22c4.05,1.946,4.079,4.913,3.973,5.86",
    transform: "translate(19.597 -3.634)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276464",
    "data-name": "Path 276464",
    d: "M56.312,32.735c5.948,2.2,4.875,6.339,4.875,6.339h5.636V32.735Z",
    transform: "translate(20.216 -3.564)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276465",
    "data-name": "Path 276465",
    d: "M66.894,39.386H61.258a.246.246,0,0,1-.19-.093.231.231,0,0,1-.042-.205c.038-.163.931-3.965-4.726-6.058a.239.239,0,0,1-.156-.269.242.242,0,0,1,.238-.2H66.894a.242.242,0,0,1,.241.241v6.341a.242.242,0,0,1-.241.241M61.542,38.9h5.11v-5.86H57.569c4.05,1.946,4.079,4.913,3.973,5.86",
    transform: "translate(20.146 -3.634)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25536",
    "data-name": "Rectangle 25536",
    width: 49.807,
    height: 69.143,
    transform: "translate(154.377 6.721)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276466",
    "data-name": "Path 276466",
    d: "M161.523,86.233H111.717a.243.243,0,0,1-.242-.241V16.847a.243.243,0,0,1,.242-.241h49.806a.243.243,0,0,1,.242.241V85.993a.243.243,0,0,1-.242.241m-49.565-.481h49.326V17.087H111.958Z",
    transform: "translate(42.66 -10.127)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25537",
    "data-name": "Rectangle 25537",
    width: 45.483,
    height: 63.14,
    transform: "translate(156.539 9.723)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87902",
    "data-name": "Group 87902",
    transform: "translate(156.539 9.723)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87901",
    "data-name": "Group 87901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87900",
    "data-name": "Group 87900",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25538",
    "data-name": "Rectangle 25538",
    width: 45.483,
    height: 63.14,
    transform: "translate(0)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276467",
    "data-name": "Path 276467",
    d: "M157.159,82.364H117.127a.237.237,0,0,1-.229-.167.242.242,0,0,1,.089-.267,18.562,18.562,0,0,0,4.489-4.738.245.245,0,0,1,.335-.069.242.242,0,0,1,.069.333,19.261,19.261,0,0,1-4.038,4.427h39.077V19.221h-7.095c-.307.094-.622.191-.936.291-8.178,2.572-15.013,10.108-18.749,20.675a.232.232,0,0,1-.307.143.236.236,0,0,1-.144-.307c3.786-10.71,10.73-18.353,19.052-20.969.329-.106.66-.207.978-.3a.245.245,0,0,1,.07-.011h7.371a.241.241,0,0,1,.241.241V82.124a.241.241,0,0,1-.241.241",
    transform: "translate(44.861 -9.259)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276468",
    "data-name": "Path 276468",
    d: "M121.054,69.243a.259.259,0,0,1-.117-.031.237.237,0,0,1-.093-.326c2.275-4.132,3.545-9.467,3.779-15.851a68.917,68.917,0,0,1,2.772-17.615.244.244,0,0,1,.3-.159.238.238,0,0,1,.159.3A68.682,68.682,0,0,0,125.1,53.05c-.236,6.462-1.526,11.867-3.841,16.069a.239.239,0,0,1-.21.124",
    transform: "translate(46.459 -2.541)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276469",
    "data-name": "Path 276469",
    d: "M133.15,64.98a.246.246,0,0,1-.2-.1c-3.265-4.664-4.209-9.495-2.8-14.353,2.959-10.2,11.04-16.7,17.3-20.36a.239.239,0,0,1,.241.412c-6.178,3.616-14.159,10.034-17.078,20.08-1.367,4.714-.447,9.406,2.734,13.941a.248.248,0,0,1-.059.339.268.268,0,0,1-.139.042",
    transform: "translate(50.002 -4.623)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276470",
    "data-name": "Path 276470",
    d: "M150.59,78.4h-3.126a.281.281,0,0,1-.113-.027c-4.245-2.281-10.159-6.007-14.263-10.819a.239.239,0,0,1,.027-.338.23.23,0,0,1,.338.027c4.039,4.734,9.872,8.414,14.073,10.675h2.824V29.094c-.8.377-1.628.8-2.482,1.259a.242.242,0,0,1-.225-.428c.982-.528,1.941-1.01,2.846-1.429a.219.219,0,0,1,.229.015.239.239,0,0,1,.113.2v49.45a.241.241,0,0,1-.241.241",
    transform: "translate(51.43 -5.299)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276471",
    "data-name": "Path 276471",
    d: "M113.254,48.106a.256.256,0,0,1-.073-.011.244.244,0,0,1-.167-.229V18.981a.241.241,0,0,1,.241-.241h11.009a.242.242,0,0,1,.241.214c.393,3.541.11,9.3-3.471,16.593a.244.244,0,0,1-.322.113.24.24,0,0,1-.113-.322c3.464-7.051,3.8-12.62,3.448-16.116H113.494V47.1c1.712-2.485,3.585-5.476,5.577-8.908l.1-.167c.108-.194.221-.384.326-.578a.234.234,0,0,1,.326-.093.238.238,0,0,1,.093.326c-.106.194-.218.388-.331.587l-.093.166c-2.171,3.739-4.2,6.96-6.038,9.572a.252.252,0,0,1-.2.1",
    transform: "translate(43.286 -9.259)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276472",
    "data-name": "Path 276472",
    d: "M120.047,59.625c-2.5,0-4.47-3.887-4.47-8.851s1.965-8.845,4.47-8.845,4.47,3.887,4.47,8.845a.241.241,0,1,1-.481,0c0-4.613-1.791-8.364-3.988-8.364s-3.988,3.751-3.988,8.364,1.791,8.369,3.988,8.369c1.709,0,3.27-2.4,3.8-5.826a.243.243,0,0,1,.238-.205.093.093,0,0,1,.034,0,.24.24,0,0,1,.2.272c-.574,3.732-2.295,6.237-4.275,6.237",
    transform: "translate(44.329 0.176)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276473",
    "data-name": "Path 276473",
    d: "M122.354,40.252c-1.154,0-2.054-1.566-2.054-3.565s.9-3.561,2.054-3.561,2.054,1.564,2.054,3.561-.9,3.565-2.054,3.565m0-6.645c-.854,0-1.573,1.41-1.573,3.08s.719,3.082,1.573,3.082,1.573-1.412,1.573-3.082-.719-3.08-1.573-3.08",
    transform: "translate(46.25 -3.405)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276474",
    "data-name": "Path 276474",
    d: "M138.91,54.779c-3.631,0-6.586-2.21-6.586-4.924s2.954-4.92,6.586-4.92a8.773,8.773,0,0,1,1.709.166.242.242,0,0,1-.094.474,8.188,8.188,0,0,0-1.615-.159c-3.367,0-6.1,1.992-6.1,4.439s2.738,4.443,6.1,4.443,6.1-1.992,6.1-4.443a4.31,4.31,0,0,0-2.764-3.717.24.24,0,0,1-.113-.322.247.247,0,0,1,.322-.113,4.772,4.772,0,0,1,3.037,4.152c0,2.714-2.952,4.924-6.583,4.924",
    transform: "translate(51.143 1.399)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276475",
    "data-name": "Path 276475",
    d: "M137.844,51.275c-1.6,0-2.9-.99-2.9-2.206s1.3-2.2,2.9-2.2,2.9.986,2.9,2.2-1.3,2.206-2.9,2.206m0-3.927c-1.337,0-2.42.772-2.42,1.721s1.083,1.723,2.42,1.723,2.42-.772,2.42-1.723-1.083-1.721-2.42-1.721",
    transform: "translate(52.208 2.185)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276476",
    "data-name": "Path 276476",
    d: "M140.611,43.766c-1.965,0-3.565-1.328-3.565-2.959s1.6-2.959,3.565-2.959,3.565,1.328,3.565,2.959-1.6,2.959-3.565,2.959m0-5.436c-1.7,0-3.084,1.11-3.084,2.477s1.383,2.477,3.084,2.477,3.084-1.11,3.084-2.477-1.383-2.477-3.084-2.477",
    transform: "translate(53.064 -1.484)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276477",
    "data-name": "Path 276477",
    d: "M125.6,32.76c-1.405,0-2.5-2.559-2.5-5.829s1.1-5.829,2.5-5.829,2.5,2.559,2.5,5.829-1.1,5.829-2.5,5.829m0-11.176c-.979,0-2.023,2.147-2.023,5.348s1.044,5.348,2.023,5.348,2.023-2.148,2.023-5.348-1.044-5.348-2.023-5.348",
    transform: "translate(47.387 -8.297)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276478",
    "data-name": "Path 276478",
    d: "M128.008,63.782a3.413,3.413,0,1,1,3.413-3.413,3.415,3.415,0,0,1-3.413,3.413m0-6.345a2.932,2.932,0,1,0,2.932,2.932,2.937,2.937,0,0,0-2.932-2.932",
    transform: "translate(47.998 6.29)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276479",
    "data-name": "Path 276479",
    d: "M139.036,28.732a2.2,2.2,0,1,1,2.206-2.206,2.206,2.206,0,0,1-2.206,2.206m0-3.927a1.722,1.722,0,1,0,1.725,1.721,1.723,1.723,0,0,0-1.725-1.721",
    transform: "translate(52.978 -6.987)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276480",
    "data-name": "Path 276480",
    d: "M130.618,37.437a1.3,1.3,0,1,1,1.3-1.3,1.3,1.3,0,0,1-1.3,1.3m0-2.113a.815.815,0,1,0,.816.816.818.818,0,0,0-.816-.816",
    transform: "translate(49.919 -2.707)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276481",
    "data-name": "Path 276481",
    d: "M158.735,82.364H113.254a.243.243,0,0,1-.241-.242V18.981a.241.241,0,0,1,.241-.241h45.481a.241.241,0,0,1,.241.241V82.122a.243.243,0,0,1-.241.242m-45.241-.483h45V19.221h-45Z",
    transform: "translate(43.286 -9.259)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25540",
    "data-name": "Rectangle 25540",
    width: 12.354,
    height: 4.651,
    transform: "translate(115.334 99.753)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276482",
    "data-name": "Path 276482",
    d: "M96.317,87.867H83.965a.241.241,0,0,1-.241-.241V82.974a.241.241,0,0,1,.241-.241H96.317a.243.243,0,0,1,.242.241v4.653a.243.243,0,0,1-.242.241m-12.112-.481H96.076V83.214H84.205Z",
    transform: "translate(31.369 16.778)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276483",
    "data-name": "Path 276483",
    d: "M118.685,94.428H69.507l2.328-38.119h49.178Z",
    transform: "translate(25.584 6.027)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276484",
    "data-name": "Path 276484",
    d: "M118.754,94.738H69.576a.234.234,0,0,1-.174-.077.228.228,0,0,1-.066-.179l2.33-38.118a.242.242,0,0,1,.241-.227h49.178a.235.235,0,0,1,.174.079.233.233,0,0,1,.066.179l-2.33,38.118a.241.241,0,0,1-.241.225m-48.922-.481h48.7l2.3-37.637h-48.7Z",
    transform: "translate(25.514 5.957)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276485",
    "data-name": "Path 276485",
    d: "M117.682,94.428H68.5l2.328-38.119H120.01Z",
    transform: "translate(25.176 6.027)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276486",
    "data-name": "Path 276486",
    d: "M117.752,94.738H68.574a.234.234,0,0,1-.174-.077.228.228,0,0,1-.066-.179l2.326-38.118a.243.243,0,0,1,.241-.227h49.178a.248.248,0,0,1,.241.257l-2.326,38.118a.241.241,0,0,1-.241.225M68.83,94.257h48.7l2.3-37.637h-48.7Z",
    transform: "translate(25.107 5.957)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276487",
    "data-name": "Path 276487",
    d: "M114.251,91.7H70.537l2.07-33.884h43.714Z",
    transform: "translate(26.004 6.639)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276488",
    "data-name": "Path 276488",
    d: "M114.322,92.01H70.608a.234.234,0,0,1-.174-.077.228.228,0,0,1-.066-.179l2.065-33.886a.242.242,0,0,1,.241-.225h43.714a.239.239,0,0,1,.176.077.232.232,0,0,1,.065.179l-2.065,33.886a.241.241,0,0,1-.241.225m-43.458-.481H114.1l2.034-33.4H72.9Z",
    transform: "translate(25.934 6.57)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276489",
    "data-name": "Path 276489",
    d: "M101.16,85.861h-29.7l1.6-26.113h29.7Z",
    transform: "translate(26.381 7.426)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276490",
    "data-name": "Path 276490",
    d: "M101.227,86.17H71.533a.234.234,0,0,1-.174-.077.228.228,0,0,1-.066-.179l1.6-26.111a.242.242,0,0,1,.241-.225h29.7a.245.245,0,0,1,.241.256l-1.6,26.111a.243.243,0,0,1-.242.225m-29.439-.481H101l1.566-25.63H73.353Z",
    transform: "translate(26.311 7.357)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276491",
    "data-name": "Path 276491",
    d: "M81.952,70.39S75.769,72.84,75.728,73.5s-1.249,8.108-1.249,8.108H92.863l-1.55-8.579-6.8-2.828Z",
    transform: "translate(27.607 11.679)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276492",
    "data-name": "Path 276492",
    d: "M92.932,81.917H74.55a.241.241,0,0,1-.238-.279c.415-2.572,1.216-7.573,1.246-8.085.039-.668,3.488-2.175,6.373-3.32A.293.293,0,0,1,82,70.217l2.555-.187a.263.263,0,0,1,.113.02l6.8,2.826a.247.247,0,0,1,.145.179l1.549,8.579a.263.263,0,0,1-.051.2.251.251,0,0,1-.187.084m-18.1-.481H92.645l-1.476-8.167-6.628-2.753-2.466.179c-2.819,1.123-5.841,2.517-6.043,2.921-.031.571-.979,6.442-1.2,7.821",
    transform: "translate(27.538 11.61)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276493",
    "data-name": "Path 276493",
    d: "M80.6,69.275a3.247,3.247,0,0,0-1.266.66,7.663,7.663,0,0,0-1.069,2.074l-.021,1.885,2.438-1.32,2.462-.189,2.319,2.168.3-3.3s-.357-1.885-1.106-1.979-4.053,0-4.053,0",
    transform: "translate(29.141 11.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276494",
    "data-name": "Path 276494",
    d: "M85.537,74.863a.235.235,0,0,1-.163-.065l-2.241-2.093-2.306.179-2.4,1.289a.239.239,0,0,1-.355-.214l.024-1.882A.2.2,0,0,1,78.115,72a7.377,7.377,0,0,1,1.13-2.167,3.41,3.41,0,0,1,1.372-.718.224.224,0,0,1,.051-.008c.135-.007,3.331-.1,4.093,0,.878.108,1.242,1.829,1.308,2.175a.312.312,0,0,1,0,.065l-.3,3.3a.247.247,0,0,1-.155.2.21.21,0,0,1-.086.015m-2.319-2.648a.231.231,0,0,1,.163.066l1.961,1.829.249-2.773c-.136-.691-.505-1.705-.893-1.754-.677-.082-3.666-.008-3.988,0a2.931,2.931,0,0,0-1.134.6,6.764,6.764,0,0,0-.995,1.941l-.02,1.436,2.082-1.123a.22.22,0,0,1,.093-.031l2.462-.19Z",
    transform: "translate(29.071 11.215)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276495",
    "data-name": "Path 276495",
    d: "M79.9,67.99l-.107,3.3,1.459,2.357,2.411-2.451.373-3.016Z",
    transform: "translate(29.769 10.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276496",
    "data-name": "Path 276496",
    d: "M81.32,73.956h-.027a.255.255,0,0,1-.179-.114l-1.46-2.356a.274.274,0,0,1-.035-.136l.108-3.3a.246.246,0,0,1,.077-.167.339.339,0,0,1,.176-.066l4.135.187a.254.254,0,0,1,.173.086.227.227,0,0,1,.052.186L83.968,71.3a.2.2,0,0,1-.065.135L81.49,73.881a.245.245,0,0,1-.17.075m-1.214-2.665,1.256,2.034,2.14-2.171.331-2.679L80.2,68.313Z",
    transform: "translate(29.699 10.71)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276497",
    "data-name": "Path 276497",
    d: "M86.206,66.7c-.169,2.766-2.008,6.118-4.024,6.118s-3.444-3.353-3.275-6.118,1.94-5.007,3.955-5.007,3.513,2.241,3.344,5.007",
    transform: "translate(29.404 8.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276498",
    "data-name": "Path 276498",
    d: "M82.251,73.125a2.517,2.517,0,0,1-1.818-.889,7.892,7.892,0,0,1-1.7-5.483c.174-2.885,2.054-5.235,4.2-5.235a3.069,3.069,0,0,1,2.262,1.033,5.751,5.751,0,0,1,1.321,4.233c-.176,2.873-2.117,6.341-4.264,6.341M82.932,62c-1.888,0-3.555,2.147-3.713,4.785a7.467,7.467,0,0,0,1.567,5.125,2.032,2.032,0,0,0,1.465.734c1.844,0,3.623-3.239,3.782-5.891a5.222,5.222,0,0,0-1.192-3.872A2.579,2.579,0,0,0,82.932,62",
    transform: "translate(29.334 8.146)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276499",
    "data-name": "Path 276499",
    d: "M79.157,65.765s-.651-1.7-.922-.377S79.3,68.122,79.3,68.122Z",
    transform: "translate(29.121 9.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276500",
    "data-name": "Path 276500",
    d: "M79.366,68.43a.234.234,0,0,1-.174-.077c-.058-.058-1.41-1.518-1.123-2.943.039-.183.136-.664.5-.695H78.6c.4,0,.7.64.854,1.033a.631.631,0,0,1,.015.07l.139,2.356a.249.249,0,0,1-.144.238.3.3,0,0,1-.1.018m-.741-3.2a1,1,0,0,0-.082.272,2.755,2.755,0,0,0,.536,1.915l-.09-1.533a2.713,2.713,0,0,0-.364-.653",
    transform: "translate(29.052 9.447)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276501",
    "data-name": "Path 276501",
    d: "M84.233,65.295s1.593-.67,1.128.744a2.8,2.8,0,0,1-1.618,1.791Z",
    transform: "translate(31.377 9.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276502",
    "data-name": "Path 276502",
    d: "M83.813,68.142a.227.227,0,0,1-.159-.063.241.241,0,0,1-.077-.225l.49-2.535a.24.24,0,0,1,.144-.174c.155-.066.943-.366,1.344,0,.229.211.263.56.108,1.037a3.025,3.025,0,0,1-1.774,1.946.23.23,0,0,1-.075.013m.7-2.6-.369,1.919A2.688,2.688,0,0,0,85.2,66.038c.09-.269.1-.47.024-.536-.113-.106-.45-.046-.715.042",
    transform: "translate(31.307 9.55)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276503",
    "data-name": "Path 276503",
    d: "M81.855,65.893a1.227,1.227,0,0,0-1.239-1.32,1.421,1.421,0,0,0-1.4,1.32,1.226,1.226,0,0,0,1.239,1.32,1.422,1.422,0,0,0,1.4-1.32",
    transform: "translate(29.534 9.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276504",
    "data-name": "Path 276504",
    d: "M80.523,67.521a1.477,1.477,0,0,1-1.48-1.576A1.672,1.672,0,0,1,80.686,64.4a1.479,1.479,0,0,1,1.083.457,1.5,1.5,0,0,1,.4,1.116,1.669,1.669,0,0,1-1.643,1.545m.163-2.636a1.18,1.18,0,0,0-1.161,1.092.985.985,0,0,0,1,1.064,1.175,1.175,0,0,0,1.161-1.095.978.978,0,0,0-1-1.061",
    transform: "translate(29.463 9.32)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276505",
    "data-name": "Path 276505",
    d: "M83.438,65.928a.239.239,0,0,1-.234-.179.244.244,0,0,1,.172-.3l1.436-.376a.233.233,0,0,1,.3.17.241.241,0,0,1-.172.3L83.5,65.92a.343.343,0,0,1-.062.008",
    transform: "translate(31.154 9.592)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276506",
    "data-name": "Path 276506",
    d: "M84.133,65.893a1.227,1.227,0,0,0-1.239-1.32,1.421,1.421,0,0,0-1.4,1.32,1.226,1.226,0,0,0,1.239,1.32,1.422,1.422,0,0,0,1.4-1.32",
    transform: "translate(30.46 9.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276507",
    "data-name": "Path 276507",
    d: "M82.8,67.521a1.464,1.464,0,0,1-1.48-1.576A1.662,1.662,0,0,1,82.962,64.4a1.463,1.463,0,0,1,1.48,1.573A1.665,1.665,0,0,1,82.8,67.521m.159-2.636A1.176,1.176,0,0,0,81.8,65.976a.986.986,0,0,0,1,1.064,1.174,1.174,0,0,0,1.156-1.095.98.98,0,0,0-1-1.061",
    transform: "translate(30.391 9.32)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276508",
    "data-name": "Path 276508",
    d: "M82.743,61.416a3.482,3.482,0,0,0-2.528-.283c-1.066.471-1.881,3.016-1.828,3.676a18.639,18.639,0,0,0,.694,2.546l1.144-3.3,3-1.32Z",
    transform: "translate(29.197 7.927)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276509",
    "data-name": "Path 276509",
    d: "M79.15,67.662h0a.241.241,0,0,1-.228-.163,18.84,18.84,0,0,1-.708-2.6c-.053-.722.765-3.378,1.972-3.918a3.768,3.768,0,0,1,2.735.291.224.224,0,0,1,.115.132l.485,1.32a.241.241,0,0,1-.128.3l-2.9,1.277L79.377,67.5a.241.241,0,0,1-.227.163m1.934-6.376a1.751,1.751,0,0,0-.7.136c-.947.419-1.728,2.873-1.685,3.436a11.991,11.991,0,0,0,.463,1.811l.913-2.621A.226.226,0,0,1,80.2,63.9L83,62.676l-.373-1.017a4.069,4.069,0,0,0-1.538-.373",
    transform: "translate(29.126 7.858)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276510",
    "data-name": "Path 276510",
    d: "M80.453,62.107s2.378-1.885,4.3-.943a2.9,2.9,0,0,1,1.7,3.111c-.028.471-.066,2.639-.066,2.639l-1.142.189-.551-1.791a16.565,16.565,0,0,1-1.891-.9s-2.559-.328-2.344-2.307",
    transform: "translate(30.033 7.895)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276511",
    "data-name": "Path 276511",
    d: "M85.309,67.414a.235.235,0,0,1-.229-.17l-.516-1.681a16.7,16.7,0,0,1-1.775-.847c-.975-.139-2.691-.843-2.508-2.566a.258.258,0,0,1,.093-.163c.1-.079,2.539-1.954,4.555-.971A3.112,3.112,0,0,1,86.761,64.3c-.031.516-.07,2.663-.07,2.683a.24.24,0,0,1-.2.232l-1.142.191a.172.172,0,0,1-.038,0M80.75,62.3c-.086,1.631,2.054,1.926,2.147,1.941a.226.226,0,0,1,.086.027,16.252,16.252,0,0,0,1.86.882.235.235,0,0,1,.144.155l.49,1.593.739-.124c.011-.547.038-2.054.062-2.451a2.656,2.656,0,0,0-1.557-2.877c-1.58-.774-3.541.551-3.969.854",
    transform: "translate(29.962 7.826)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276512",
    "data-name": "Path 276512",
    d: "M81.139,65.511l-.167,2.734h.66",
    transform: "translate(30.249 9.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276513",
    "data-name": "Path 276513",
    d: "M81.7,68.554h-.66a.234.234,0,0,1-.174-.077A.228.228,0,0,1,80.8,68.3l.166-2.734a.227.227,0,0,1,.256-.225.243.243,0,0,1,.227.256L81.3,68.073h.4a.241.241,0,0,1,0,.481",
    transform: "translate(30.18 9.701)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11047",
    "data-name": "Line 11047",
    x2: 1.414,
    transform: "translate(110.875 79.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276514",
    "data-name": "Path 276514",
    d: "M82.209,68.5H80.8a.241.241,0,1,1,0-.481h1.414a.241.241,0,0,1,0,.481",
    transform: "translate(30.08 10.792)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276515",
    "data-name": "Path 276515",
    d: "M80.526,80.9H80.51a.242.242,0,0,1-.225-.256l.523-8.579a.241.241,0,0,1,.242-.225h.015a.244.244,0,0,1,.225.257l-.525,8.578a.238.238,0,0,1-.241.225",
    transform: "translate(29.97 12.345)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276516",
    "data-name": "Path 276516",
    d: "M84.876,80.913h-.027a.247.247,0,0,1-.214-.267c0-.02.221-2.078.28-3.006a36.436,36.436,0,0,1,2.046-5.456.243.243,0,0,1,.319-.124.246.246,0,0,1,.124.318A36.192,36.192,0,0,0,85.4,77.671c-.059.936-.28,3.006-.28,3.029a.245.245,0,0,1-.241.214",
    transform: "translate(31.739 12.427)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276517",
    "data-name": "Path 276517",
    d: "M77.594,80.776h-.02a.242.242,0,0,1-.221-.26,18.929,18.929,0,0,0,.086-3.922c-.245-.466-2.19-3.825-2.21-3.859a.243.243,0,0,1,.089-.331.255.255,0,0,1,.331.089c.077.141,1.965,3.4,2.217,3.876.264.494.044,3.331-.031,4.187a.241.241,0,0,1-.241.221",
    transform: "translate(27.9 12.564)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276518",
    "data-name": "Path 276518",
    d: "M87.377,76.317l.65-2.922,1.106-1.131,1.047-1.7h.471l-.581,1.792,1.466-.848L92.477,70l.547.283-1.344,3.489-2.137,1.037-.37,1.414Z",
    transform: "translate(32.855 11.597)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276519",
    "data-name": "Path 276519",
    d: "M87.449,76.625a.242.242,0,0,1-.183-.084.226.226,0,0,1-.051-.207l.649-2.919a.215.215,0,0,1,.062-.117l1.107-1.13,1.01-1.654a.237.237,0,0,1,.205-.117h.474a.242.242,0,0,1,.194.1.23.23,0,0,1,.034.212L90.562,71.9l.871-.505.912-1.456a.23.23,0,0,1,.311-.086l.547.284a.238.238,0,0,1,.117.3l-1.344,3.488a.256.256,0,0,1-.12.132l-2.04.986-.34,1.308a.245.245,0,0,1-.222.179l-1.794.093Zm.869-3.04-.567,2.544,1.3-.066.324-1.246a.246.246,0,0,1,.128-.155l2.054-.995,1.231-3.2-.159-.082-.827,1.32a.281.281,0,0,1-.082.082l-1.465.851a.247.247,0,0,1-.272-.024.239.239,0,0,1-.077-.26l.481-1.476h-.008l-.974,1.581Z",
    transform: "translate(32.786 11.527)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276520",
    "data-name": "Path 276520",
    d: "M89.735,80.109l.18-5.846-2.145-.377-1.694,6.223Z",
    transform: "translate(32.326 13.179)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276521",
    "data-name": "Path 276521",
    d: "M89.8,80.417H86.145a.246.246,0,0,1-.19-.093.242.242,0,0,1-.042-.21L87.6,73.894a.242.242,0,0,1,.234-.179.158.158,0,0,1,.042,0l2.148.377a.238.238,0,0,1,.2.243l-.181,5.846a.243.243,0,0,1-.241.232m-3.344-.481H89.57l.167-5.4-1.725-.3Z",
    transform: "translate(32.256 13.109)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276522",
    "data-name": "Path 276522",
    d: "M101.066,80.477H71.37l.134-2.168H101.2Z",
    transform: "translate(26.342 14.978)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276523",
    "data-name": "Path 276523",
    d: "M101.133,80.789H71.439a.234.234,0,0,1-.174-.077.228.228,0,0,1-.066-.179l.132-2.171a.241.241,0,0,1,.241-.225h29.695a.234.234,0,0,1,.174.077.228.228,0,0,1,.066.179l-.131,2.171a.243.243,0,0,1-.242.225m-29.439-.481h29.214l.1-1.69H71.8Z",
    transform: "translate(26.272 14.908)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11048",
    "data-name": "Line 11048",
    x2: 27.244,
    transform: "translate(98.924 94.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276524",
    "data-name": "Path 276524",
    d: "M99.545,79.223H72.3a.241.241,0,1,1,0-.481H99.545a.241.241,0,1,1,0,.481",
    transform: "translate(26.623 15.154)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276525",
    "data-name": "Path 276525",
    d: "M104.534,66.693H94.542l.421-6.882h9.993Z",
    transform: "translate(35.77 7.452)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276526",
    "data-name": "Path 276526",
    d: "M104.6,67H94.611a.236.236,0,0,1-.174-.077.233.233,0,0,1-.066-.179l.421-6.881a.241.241,0,0,1,.241-.225h9.994a.232.232,0,0,1,.174.077.234.234,0,0,1,.068.179l-.425,6.881A.24.24,0,0,1,104.6,67m-9.736-.481h9.509l.393-6.4H95.255Z",
    transform: "translate(35.7 7.383)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276527",
    "data-name": "Path 276527",
    d: "M104.534,65.03H94.542L94.61,63.9H104.6Z",
    transform: "translate(35.77 9.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276528",
    "data-name": "Path 276528",
    d: "M104.6,65.34H94.611a.236.236,0,0,1-.174-.077.233.233,0,0,1-.066-.179l.07-1.13a.241.241,0,0,1,.241-.225h9.992a.247.247,0,0,1,.242.256l-.072,1.13a.24.24,0,0,1-.239.225m-9.736-.481h9.509l.038-.649H94.908Z",
    transform: "translate(35.7 9.046)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276529",
    "data-name": "Path 276529",
    d: "M100.156,62.421l-2.6-1.553-.19,3.106Z",
    transform: "translate(36.921 7.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276530",
    "data-name": "Path 276530",
    d: "M97.44,64.285a.231.231,0,0,1-.128-.039.243.243,0,0,1-.113-.218l.19-3.106a.255.255,0,0,1,.128-.2.23.23,0,0,1,.238.008l2.594,1.553a.24.24,0,0,1-.008.415l-2.784,1.553a.247.247,0,0,1-.117.032m.408-2.94-.139,2.275,2.034-1.137Z",
    transform: "translate(36.851 7.811)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276531",
    "data-name": "Path 276531",
    d: "M104.072,74.267H94.079l.421-6.882h9.993Z",
    transform: "translate(35.582 10.533)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276532",
    "data-name": "Path 276532",
    d: "M104.142,74.577H94.151a.234.234,0,0,1-.174-.077.228.228,0,0,1-.066-.179l.419-6.881a.242.242,0,0,1,.241-.225h9.992a.245.245,0,0,1,.241.256l-.419,6.881a.24.24,0,0,1-.241.225M94.407,74.1h9.51l.388-6.4H94.8Z",
    transform: "translate(35.513 10.464)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276533",
    "data-name": "Path 276533",
    d: "M104.072,72.6H94.079l.069-1.131h9.993Z",
    transform: "translate(35.582 12.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276534",
    "data-name": "Path 276534",
    d: "M104.142,72.915H94.151a.234.234,0,0,1-.174-.077.228.228,0,0,1-.066-.179l.066-1.134a.242.242,0,0,1,.241-.225h10a.245.245,0,0,1,.241.256l-.07,1.134a.24.24,0,0,1-.241.225m-9.736-.481h9.51l.038-.653H94.442Z",
    transform: "translate(35.513 12.126)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276535",
    "data-name": "Path 276535",
    d: "M99.693,69.995l-2.6-1.553-.19,3.106Z",
    transform: "translate(36.733 10.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276536",
    "data-name": "Path 276536",
    d: "M96.977,71.86a.232.232,0,0,1-.128-.039.243.243,0,0,1-.113-.218l.19-3.106a.255.255,0,0,1,.128-.2.221.221,0,0,1,.238.008l2.6,1.553a.238.238,0,0,1,.117.21.241.241,0,0,1-.124.205l-2.788,1.553a.247.247,0,0,1-.117.032m.408-2.94L97.245,71.2l2.039-1.138Z",
    transform: "translate(36.663 10.892)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276537",
    "data-name": "Path 276537",
    d: "M103.609,81.841H93.617l.421-6.882h9.993Z",
    transform: "translate(35.394 13.615)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276538",
    "data-name": "Path 276538",
    d: "M103.678,82.152H93.687a.234.234,0,0,1-.174-.077.228.228,0,0,1-.066-.179l.419-6.885a.241.241,0,0,1,.241-.225H104.1a.245.245,0,0,1,.241.256l-.419,6.885a.24.24,0,0,1-.241.225m-9.736-.481h9.51l.388-6.4h-9.51Z",
    transform: "translate(35.324 13.545)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276539",
    "data-name": "Path 276539",
    d: "M103.609,80.178H93.617l.069-1.131h9.993Z",
    transform: "translate(35.394 15.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276540",
    "data-name": "Path 276540",
    d: "M103.678,80.489H93.687a.234.234,0,0,1-.174-.077.228.228,0,0,1-.066-.179l.069-1.134a.243.243,0,0,1,.242-.225h9.992a.245.245,0,0,1,.241.256l-.07,1.134a.24.24,0,0,1-.241.225m-9.736-.481h9.51l.038-.653H93.982Z",
    transform: "translate(35.324 15.208)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276541",
    "data-name": "Path 276541",
    d: "M99.231,77.568l-2.6-1.553-.19,3.106Z",
    transform: "translate(36.545 14.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276542",
    "data-name": "Path 276542",
    d: "M96.516,79.434a.231.231,0,0,1-.128-.039.243.243,0,0,1-.113-.218l.19-3.106a.255.255,0,0,1,.128-.2.221.221,0,0,1,.238.008l2.594,1.553a.24.24,0,0,1-.008.415L96.632,79.4a.247.247,0,0,1-.117.032m.408-2.94-.139,2.276,2.034-1.138Z",
    transform: "translate(36.475 13.974)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276543",
    "data-name": "Path 276543",
    d: "M104.338,65.819H94.63a.241.241,0,0,1,0-.481h9.709a.241.241,0,1,1,0,.481",
    transform: "translate(35.708 9.701)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276544",
    "data-name": "Path 276544",
    d: "M104.289,66.625H94.581a.241.241,0,1,1,0-.481h9.709a.241.241,0,0,1,0,.481",
    transform: "translate(35.688 10.029)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276545",
    "data-name": "Path 276545",
    d: "M103.872,73.46H94.164a.241.241,0,1,1,0-.481h9.709a.241.241,0,0,1,0,.481",
    transform: "translate(35.519 12.809)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276546",
    "data-name": "Path 276546",
    d: "M103.822,74.263H94.114a.241.241,0,1,1,0-.481h9.709a.241.241,0,0,1,0,.481",
    transform: "translate(35.498 13.136)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276547",
    "data-name": "Path 276547",
    d: "M93.139,87H85.851a2.743,2.743,0,0,1,2.743-2.743h1.8A2.743,2.743,0,0,1,93.139,87",
    transform: "translate(32.234 17.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276548",
    "data-name": "Path 276548",
    d: "M93.207,87.314H85.923a.243.243,0,0,1-.243-.241,2.989,2.989,0,0,1,2.983-2.983h1.8a2.989,2.989,0,0,1,2.983,2.983.241.241,0,0,1-.241.241m-7.032-.481h6.778a2.5,2.5,0,0,0-2.489-2.259h-1.8a2.5,2.5,0,0,0-2.487,2.259",
    transform: "translate(32.165 17.331)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25541",
    "data-name": "Rectangle 25541",
    width: 35.694,
    height: 1.497,
    transform: "translate(78.9 102.907)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276549",
    "data-name": "Path 276549",
    d: "M93.76,86.954H58.069a.243.243,0,0,1-.242-.241v-1.5a.244.244,0,0,1,.242-.241H93.76a.242.242,0,0,1,.241.241v1.5a.241.241,0,0,1-.241.241m-35.45-.481h35.21V85.46H58.31Z",
    transform: "translate(20.832 17.691)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25542",
    "data-name": "Rectangle 25542",
    width: 8.969,
    height: 1.497,
    transform: "translate(105.616 102.907)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276550",
    "data-name": "Path 276550",
    d: "M86.025,86.954H77.059a.241.241,0,0,1-.241-.241v-1.5a.242.242,0,0,1,.241-.241h8.966a.243.243,0,0,1,.242.241v1.5a.243.243,0,0,1-.242.241M77.3,86.473h8.485V85.46H77.3Z",
    transform: "translate(28.559 17.691)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276551",
    "data-name": "Path 276551",
    d: "M93.729,93.3l4.316,58.354a.84.84,0,0,0,1.678-.072L99.086,93.3Z",
    transform: "translate(35.44 21.078)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276552",
    "data-name": "Path 276552",
    d: "M98.953,152.743a1.091,1.091,0,0,1-1.079-1L93.559,93.391a.236.236,0,0,1,.066-.183.227.227,0,0,1,.174-.077h5.355a.239.239,0,0,1,.242.236l.636,58.281a1.081,1.081,0,0,1-1.079,1.095M94.06,93.612l4.3,58.094a.6.6,0,0,0,.6.556.6.6,0,0,0,.6-.606l-.633-58.043Z",
    transform: "translate(35.37 21.009)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276553",
    "data-name": "Path 276553",
    d: "M96.05,93.3l2.288,59.028a.838.838,0,0,0,.442-.746L98.142,93.3Z",
    transform: "translate(36.384 21.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276554",
    "data-name": "Path 276554",
    d: "M98.4,152.639a.274.274,0,0,1-.12-.031.251.251,0,0,1-.121-.2L95.88,93.379a.238.238,0,0,1,.241-.248H98.21a.238.238,0,0,1,.241.236l.637,58.281a1.077,1.077,0,0,1-.571.962.277.277,0,0,1-.113.028M96.37,93.612,98.6,151.306l-.629-57.694Z",
    transform: "translate(36.315 21.009)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276555",
    "data-name": "Path 276555",
    d: "M113.068,93.3l4.316,58.354a.84.84,0,0,0,1.678-.072L118.425,93.3Z",
    transform: "translate(43.308 21.078)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276556",
    "data-name": "Path 276556",
    d: "M118.291,152.743a1.091,1.091,0,0,1-1.079-1L112.9,93.391a.236.236,0,0,1,.066-.183.227.227,0,0,1,.174-.077h5.355a.239.239,0,0,1,.242.236l.636,58.281a1.07,1.07,0,0,1-.307.772,1.09,1.09,0,0,1-.772.322M113.4,93.612l4.3,58.094a.6.6,0,0,0,.6.556.589.589,0,0,0,.428-.179.579.579,0,0,0,.17-.428l-.633-58.043Z",
    transform: "translate(43.238 21.009)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276557",
    "data-name": "Path 276557",
    d: "M115.207,93.3l2.667,58.945a.837.837,0,0,0,.317-.663L117.554,93.3Z",
    transform: "translate(44.178 21.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276558",
    "data-name": "Path 276558",
    d: "M117.945,152.557a.277.277,0,0,1-.1-.02.241.241,0,0,1-.144-.21l-2.669-58.945a.256.256,0,0,1,.066-.179.249.249,0,0,1,.176-.073h2.345a.238.238,0,0,1,.241.236l.637,58.281a1.094,1.094,0,0,1-.4.854.243.243,0,0,1-.152.055M115.53,93.612l2.447,54.063-.591-54.063Z",
    transform: "translate(44.109 21.009)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276559",
    "data-name": "Path 276559",
    d: "M63.832,93.8l-4.34,57.718a.84.84,0,0,1-1.678-.072l.643-57.81Z",
    transform: "translate(20.827 21.215)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276560",
    "data-name": "Path 276560",
    d: "M58.721,152.609a1.081,1.081,0,0,1-1.079-1.095l.64-57.807a.246.246,0,0,1,.075-.172c.051-.042.132-.089.174-.066l5.378.163a.243.243,0,0,1,.172.082.252.252,0,0,1,.062.179L59.8,151.611a1.092,1.092,0,0,1-1.08,1m.039-58.649-.637,57.562a.6.6,0,0,0,.172.428.584.584,0,0,0,.426.179.6.6,0,0,0,.6-.556l4.323-57.465Z",
    transform: "translate(20.757 21.144)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276561",
    "data-name": "Path 276561",
    d: "M44.493,93.8l-4.34,57.718a.84.84,0,0,1-1.678-.072l.643-57.81Z",
    transform: "translate(12.958 21.215)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276562",
    "data-name": "Path 276562",
    d: "M39.383,152.607a1.09,1.09,0,0,1-.772-.322,1.076,1.076,0,0,1-.307-.772l.64-57.807a.24.24,0,0,1,.242-.238h.007l5.374.163a.243.243,0,0,1,.172.082.246.246,0,0,1,.062.179L40.464,151.61a1.092,1.092,0,0,1-1.08,1m.039-58.649-.637,57.562a.6.6,0,0,0,.6.606.6.6,0,0,0,.6-.556L44.3,94.105Z",
    transform: "translate(12.889 21.146)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25543",
    "data-name": "Rectangle 25543",
    width: 112.845,
    height: 9.091,
    transform: "translate(50.48 105.762)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276563",
    "data-name": "Path 276563",
    d: "M150.71,96.578H37.866a.241.241,0,0,1-.241-.241V87.247a.241.241,0,0,1,.241-.241H150.71a.241.241,0,0,1,.241.241v9.091a.241.241,0,0,1-.241.241M38.106,96.1H150.47V87.489H38.106Z",
    transform: "translate(12.613 18.517)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25544",
    "data-name": "Rectangle 25544",
    width: 32.34,
    height: 9.091,
    transform: "translate(130.986 105.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276564",
    "data-name": "Path 276564",
    d: "M127.427,96.578H95.092a.241.241,0,0,1-.241-.241V87.247a.241.241,0,0,1,.241-.241h32.335a.241.241,0,0,1,.241.241v9.091a.241.241,0,0,1-.241.241M95.332,96.1h31.854V87.489H95.332Z",
    transform: "translate(35.896 18.517)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25545",
    "data-name": "Rectangle 25545",
    width: 112.845,
    height: 2.504,
    transform: "translate(50.48 107.204)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276565",
    "data-name": "Path 276565",
    d: "M150.71,91.017H37.866a.242.242,0,0,1-.241-.241V88.271a.241.241,0,0,1,.241-.241H150.71a.241.241,0,0,1,.241.241v2.506a.242.242,0,0,1-.241.241m-112.6-.483H150.47V88.511H38.106Z",
    transform: "translate(12.613 18.933)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25546",
    "data-name": "Rectangle 25546",
    width: 116.096,
    height: 3.037,
    transform: "translate(48.855 104.459)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276566",
    "data-name": "Path 276566",
    d: "M152.808,89.6H36.713a.243.243,0,0,1-.242-.241V86.32a.243.243,0,0,1,.242-.241H152.808a.241.241,0,0,1,.241.241v3.036a.241.241,0,0,1-.241.241M36.954,89.115H152.567V86.56H36.954Z",
    transform: "translate(12.143 18.139)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25547",
    "data-name": "Rectangle 25547",
    width: 31.882,
    height: 3.037,
    transform: "translate(133.067 104.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276567",
    "data-name": "Path 276567",
    d: "M128.453,89.6H96.571a.241.241,0,0,1-.241-.241V86.32a.241.241,0,0,1,.241-.241h31.882a.241.241,0,0,1,.241.241v3.036a.241.241,0,0,1-.241.241m-31.642-.481h31.4V86.56h-31.4Z",
    transform: "translate(36.498 18.139)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276568",
    "data-name": "Path 276568",
    d: "M100.253,46.194H84.583a3.078,3.078,0,0,0-3.078,3.078v5.782a3.077,3.077,0,0,0,3.078,3.078h8.206l-3.077,8.582L95.6,58.133h4.651a3.078,3.078,0,0,0,3.078-3.078V49.272a3.079,3.079,0,0,0-3.078-3.078",
    transform: "translate(30.466 1.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276569",
    "data-name": "Path 276569",
    d: "M89.784,67.027A.229.229,0,0,1,89.675,67a.239.239,0,0,1-.117-.3l2.959-8.26H84.654a3.326,3.326,0,0,1-3.32-3.32V49.342a3.326,3.326,0,0,1,3.32-3.32h15.67a3.326,3.326,0,0,1,3.32,3.32v5.782a3.326,3.326,0,0,1-3.32,3.32H95.8l-5.817,8.476a.244.244,0,0,1-.2.106M84.654,46.5a2.843,2.843,0,0,0-2.839,2.839v5.782a2.842,2.842,0,0,0,2.839,2.838h8.2a.25.25,0,0,1,.2.1.245.245,0,0,1,.027.222l-2.445,6.83,4.834-7.048a.239.239,0,0,1,.2-.106h4.653a2.841,2.841,0,0,0,2.838-2.838V49.342a2.841,2.841,0,0,0-2.838-2.839Z",
    transform: "translate(30.397 1.842)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276570",
    "data-name": "Path 276570",
    d: "M87.721,50.894a1.119,1.119,0,1,0-1.12,1.12,1.12,1.12,0,0,0,1.12-1.12",
    transform: "translate(32.085 3.368)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276571",
    "data-name": "Path 276571",
    d: "M90.705,50.894a1.119,1.119,0,1,0-1.12,1.12,1.12,1.12,0,0,0,1.12-1.12",
    transform: "translate(33.299 3.368)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276572",
    "data-name": "Path 276572",
    d: "M93.688,50.894a1.119,1.119,0,1,0-1.12,1.12,1.12,1.12,0,0,0,1.12-1.12",
    transform: "translate(34.512 3.368)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276573",
    "data-name": "Path 276573",
    d: "M160.775,135.731H147.79a.241.241,0,1,1,0-.481h12.985a.241.241,0,1,1,0,.481",
    transform: "translate(57.337 38.145)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276574",
    "data-name": "Path 276574",
    d: "M200.31,135.731H2.157a.241.241,0,1,1,0-.481H200.31a.241.241,0,1,1,0,.481",
    transform: "translate(-1.916 38.145)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276575",
    "data-name": "Path 276575",
    d: "M60.466,81.624c-1.41-2.4-5.553-11.659-5.553-11.659a19.141,19.141,0,0,1,.6-2.929c.345-.947,1.206-3.876,1.033-4.478s-2.67-1.722-2.928-1.809.345-1.55-.6-1.894-1.292.172-1.292.172l-.357,2.4L50.262,63.16a14.511,14.511,0,0,0-1.463-.947c-.775-.431-2.584-.6-2.67.086s1.465,1.292,1.981,1.723,1.206,2.5,1.808,3.1a21.946,21.946,0,0,1,1.55,1.9l.345,1.12s1.18,11.346,1.321,14.166S53.7,94.6,54.545,95.724s.986,1.833,3.384.988,2.819-1.974,3.384-4.512.564-8.178-.846-10.575",
    transform: "translate(16.071 7.015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276576",
    "data-name": "Path 276576",
    d: "M56.331,97.4c-.816,0-1.178-.436-1.663-1.118-.077-.11-.159-.222-.248-.342-.781-1.041-1.224-6.858-1.456-11.553-.141-2.78-1.313-14.038-1.325-14.154L51.322,69.2a20.282,20.282,0,0,0-1.507-1.833,7.149,7.149,0,0,1-.982-1.681,5.766,5.766,0,0,0-.8-1.4,5.484,5.484,0,0,0-.625-.4c-.715-.423-1.526-.9-1.441-1.542a.64.64,0,0,1,.388-.508,3.475,3.475,0,0,1,2.632.243,14.518,14.518,0,0,1,1.282.812l.944-1.472.349-2.354a.183.183,0,0,1,.039-.1c.02-.031.478-.66,1.573-.263.792.287.737,1.149.7,1.666a1.991,1.991,0,0,0-.013.264c.5.21,2.788,1.223,2.991,1.933.21.73-.77,3.887-1.041,4.626A17.906,17.906,0,0,0,55.233,70c.364.816,4.185,9.316,5.509,11.573,1.425,2.418,1.469,8.073.874,10.744-.589,2.652-1.075,3.817-3.537,4.688a5.5,5.5,0,0,1-1.747.393M47.209,62.147a1.525,1.525,0,0,0-.64.108c-.121.062-.129.121-.132.143-.044.326.71.77,1.211,1.065a5.772,5.772,0,0,1,.687.442,5.554,5.554,0,0,1,.933,1.566,7.054,7.054,0,0,0,.889,1.549,22.568,22.568,0,0,1,1.577,1.922.239.239,0,0,1,.034.075l.342,1.118c.024.159,1.193,11.432,1.337,14.223.318,6.446.816,10.563,1.359,11.289.093.125.179.242.256.355.626.881.889,1.234,2.855.551,2.257-.8,2.66-1.771,3.234-4.339.582-2.632.5-8.158-.819-10.4-1.4-2.38-5.4-11.3-5.568-11.681A.235.235,0,0,1,54.747,70a18.355,18.355,0,0,1,.613-2.978,16.867,16.867,0,0,0,1.028-4.33c-.12-.419-2.319-1.5-2.773-1.646-.267-.09-.248-.381-.225-.715.039-.56.035-1.03-.384-1.185-.609-.221-.9-.035-.982.051l-.35,2.334a.191.191,0,0,1-.035.093l-1.106,1.732a.235.235,0,0,1-.159.108.22.22,0,0,1-.187-.042,13.82,13.82,0,0,0-1.436-.931,3.511,3.511,0,0,0-1.542-.346m6.559-1.557.02.008a.028.028,0,0,1-.02-.008",
    transform: "translate(16.003 6.946)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276577",
    "data-name": "Path 276577",
    d: "M59.347,85.959c.564-2.538.564-8.178-.846-10.575-.153-.26-.34-.606-.55-1.009a9.474,9.474,0,0,0-6.218.587l-.774.339c.1,1.178.18,2.164.21,2.763.141,2.819.564,10.293,1.41,11.421s.988,1.832,3.385.986,2.819-1.974,3.384-4.512",
    transform: "translate(18.038 13.255)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276578",
    "data-name": "Path 276578",
    d: "M54.365,91.159c-.816,0-1.176-.435-1.662-1.118l-.249-.342c-.781-1.04-1.224-6.857-1.456-11.552-.028-.536-.1-1.438-.21-2.753a.245.245,0,0,1,.143-.241l.772-.342a9.558,9.558,0,0,1,6.38-.6.226.226,0,0,1,.148.117c.205.4.393.741.544,1,1.425,2.423,1.467,8.077.874,10.748-.591,2.652-1.076,3.817-3.538,4.686a5.45,5.45,0,0,1-1.747.393M51.282,75.525c.106,1.227.172,2.077.2,2.6.318,6.446.816,10.563,1.363,11.289.089.121.174.241.252.353.626.882.889,1.235,2.855.551,2.257-.8,2.66-1.77,3.234-4.337.582-2.632.5-8.158-.819-10.4-.148-.241-.318-.559-.512-.927a9.442,9.442,0,0,0-5.943.6Zm8.136,10.5h0Z",
    transform: "translate(17.969 13.184)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276579",
    "data-name": "Path 276579",
    d: "M51.765,47.885a16.574,16.574,0,0,1,.58,3.91c0,1.882-.58,3.042.29,3.62s1.593.58,1.448,1.737a3.116,3.116,0,0,1-.725,1.739,60.144,60.144,0,0,1-.578,6.515c-.29.58-4.055-.145-4.924-.29s-3.33,1.014-4.924-2.171-.29-7.966,2.607-10.426a70.844,70.844,0,0,1,6.227-4.634",
    transform: "translate(14.492 2.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276580",
    "data-name": "Path 276580",
    d: "M51.938,65.938a24.629,24.629,0,0,1-3.772-.466l-.283-.051a2.439,2.439,0,0,0-.668.031,3.805,3.805,0,0,1-4.43-2.33C41.177,59.907,42.4,55,45.453,52.4A71.785,71.785,0,0,1,51.7,47.753a.243.243,0,0,1,.366.135,16.829,16.829,0,0,1,.585,3.977,13.946,13.946,0,0,1-.115,1.631c-.113,1-.148,1.491.3,1.787.2.132.388.232.563.326.6.318,1.123.594.99,1.646a3.477,3.477,0,0,1-.726,1.8,49.811,49.811,0,0,1-.6,6.528c-.1.214-.384.353-1.121.353m-4.2-1.006a1.415,1.415,0,0,1,.225.015l.287.051c3.5.618,4.253.485,4.392.357a51.7,51.7,0,0,0,.544-6.408.248.248,0,0,1,.069-.159,2.863,2.863,0,0,0,.661-1.6c.089-.723-.172-.858-.743-1.161a6.7,6.7,0,0,1-.6-.346c-.71-.474-.625-1.255-.512-2.245a12.867,12.867,0,0,0,.113-1.576,15.833,15.833,0,0,0-.485-3.523,69.305,69.305,0,0,0-5.922,4.427c-2.9,2.462-4.066,7.106-2.552,10.135a3.38,3.38,0,0,0,3.949,2.069c.214-.023.408-.042.575-.042",
    transform: "translate(14.423 2.53)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276581",
    "data-name": "Path 276581",
    d: "M48.641,51.467a.185.185,0,0,1-.089-.02.234.234,0,0,1-.132-.311,1.106,1.106,0,0,1,.695-.73,1.134,1.134,0,0,1,.865.183.245.245,0,0,1,.051.338.249.249,0,0,1-.338.051.65.65,0,0,0-.349-.12.3.3,0,0,0-.1.015c-.152.042-.28.19-.381.442a.234.234,0,0,1-.221.152",
    transform: "translate(16.998 3.613)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276582",
    "data-name": "Path 276582",
    d: "M49.13,54.434a.238.238,0,0,1-.225-.155,3.685,3.685,0,0,1-.113-1.888.232.232,0,0,1,.283-.183.235.235,0,0,1,.183.284,3.315,3.315,0,0,0,.1,1.615.242.242,0,0,1-.139.311.236.236,0,0,1-.086.015",
    transform: "translate(17.126 4.354)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276583",
    "data-name": "Path 276583",
    d: "M50.084,57.762a1.2,1.2,0,0,1-.547-.128,1.271,1.271,0,0,1-.613-.808.238.238,0,0,1,.159-.3.231.231,0,0,1,.3.159.821.821,0,0,0,.377.521.775.775,0,0,0,.56.044.236.236,0,0,1,.3.155.239.239,0,0,1-.155.3,1.257,1.257,0,0,1-.381.055",
    transform: "translate(17.205 6.112)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276584",
    "data-name": "Path 276584",
    d: "M56.608,77.207s-.5,2.2-.91,3.367-8.1,3.3-11.445,3.745a57.193,57.193,0,0,1-6.639.438l.211,6.089s6.472.127,6.932.02,11.353-5,11.353-5l4.707-.616s1.975-.476,2.051-2.015-1.67-5.893-2.461-6.573-2.47-2.477-3.474-1.37-.326,1.92-.326,1.92",
    transform: "translate(12.608 13.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276585",
    "data-name": "Path 276585",
    d: "M43.055,91.218c-1.829,0-4.447-.046-5.165-.062a.244.244,0,0,1-.238-.234l-.21-6.089a.258.258,0,0,1,.066-.174.247.247,0,0,1,.174-.075,57.645,57.645,0,0,0,6.609-.435c3.794-.505,10.924-2.66,11.251-3.588.349-1,.772-2.8.876-3.239a1.725,1.725,0,0,1,.405-2.129,1.416,1.416,0,0,1,1.867-.172,8.417,8.417,0,0,1,1.615,1.228c.121.108.229.21.326.291.858.737,2.625,5.18,2.544,6.768-.082,1.7-2.147,2.217-2.233,2.237l-4.7.613c-1.262.567-10.9,4.9-11.366,5.006a16.68,16.68,0,0,1-1.825.051m-4.928-.54c2.5.055,6.329.1,6.645.024.377-.1,6.97-3.042,11.311-4.99a.125.125,0,0,1,.066-.02l4.707-.613c-.008,0,1.778-.454,1.84-1.791.073-1.429-1.624-5.732-2.372-6.38-.1-.086-.214-.186-.339-.3a7.914,7.914,0,0,0-1.514-1.158c-.75-.388-1.092-.139-1.289.066-.851.944-.326,1.6-.319,1.6a.239.239,0,0,1,.046.21c-.02.09-.508,2.228-.916,3.391-.481,1.379-8.6,3.5-11.639,3.9a56.952,56.952,0,0,1-6.422.439Z",
    transform: "translate(12.539 13.537)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276586",
    "data-name": "Path 276586",
    d: "M42.218,85.407c0-2.635.675-2.7,1.431-3.744a58.313,58.313,0,0,1-5.989.357L37.5,87.606s3.544.326,5.7.47c-.165.287-.986-.979-.986-2.669",
    transform: "translate(12.563 16.343)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276587",
    "data-name": "Path 276587",
    d: "M43.209,88.424a.306.306,0,0,1-.086-.011.426.426,0,0,1-.1-.042c-2.151-.152-5.436-.454-5.471-.454a.243.243,0,0,1-.218-.249l.159-5.584a.242.242,0,0,1,.242-.234,58.136,58.136,0,0,0,5.959-.357.237.237,0,0,1,.234.121.229.229,0,0,1-.011.26c-.163.225-.322.408-.47.578-.532.6-.913,1.033-.913,3.025A4.265,4.265,0,0,0,43.2,87.9l.089,0a.253.253,0,0,1,.2.129.243.243,0,0,1,0,.232.311.311,0,0,1-.276.159m.055-.47h0Zm-5.445-.5c.715.062,3,.267,4.781.4a5.265,5.265,0,0,1-.551-2.38c0-2.171.454-2.687,1.033-3.343.027-.031.055-.066.086-.1-2.358.245-4.509.287-5.2.294Z",
    transform: "translate(12.493 16.272)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276588",
    "data-name": "Path 276588",
    d: "M69.463,105.653a22.571,22.571,0,0,0-9.457-6.3l-8.443,3.6a19.222,19.222,0,0,0-2.59-4.5L47.4,96.533l1.013-5.516s6.079-4.166,6.867-5.967c.008-.018.02-.038.028-.058,1.218,1.891,6.519,10.069,7.515,10.865,1.125.9,4.5,1.013,5.967-.338s2.138-2.251,1.8-4.278c0,0-2.251-4.841-3.489-6.979S63.159,74.468,61.808,72.1a32.982,32.982,0,0,0-2.044-3.687,13.443,13.443,0,0,0-1.671-2.279c-1.351-1.465-5.066-1.8-5.854-2.14a37.7,37.7,0,0,0-5.4-1.8c-4.5-1.351-9.57-2.14-13.172.675a36.683,36.683,0,0,0-6.754,15.2c-1.913,9.457-2.026,19.025-2.251,20.715s-2.14,9.907-2.7,14.634,4.391,9.457,7.43,10.922,16.1,1.688,23.755,0S72.954,115,72.954,115a13.6,13.6,0,0,0-3.49-9.344",
    transform: "translate(6.219 7.924)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276589",
    "data-name": "Path 276589",
    d: "M40.154,125.826c-4.88,0-9.215-.435-10.8-1.2-2.842-1.37-8.158-6.2-7.565-11.163.366-3.073,1.29-7.576,1.97-10.865.364-1.78.653-3.189.733-3.775.051-.388.1-1.22.163-2.373a129.828,129.828,0,0,1,2.089-18.36,37.3,37.3,0,0,1,6.808-15.3c3.962-3.1,9.561-1.911,13.424-.75A41.415,41.415,0,0,1,52.2,63.757l.205.089a8.959,8.959,0,0,0,1.169.291c1.487.315,3.735.789,4.765,1.9a13.356,13.356,0,0,1,1.705,2.326,9.514,9.514,0,0,1,1.106,1.9c.26.521.551,1.114.94,1.791.691,1.216,1.736,3.8,2.746,6.3.955,2.368,1.946,4.819,2.546,5.86,1.228,2.124,3.472,6.947,3.5,7a.151.151,0,0,1,.018.062c.373,2.228-.5,3.227-1.875,4.494-1.576,1.459-5.114,1.277-6.279.349-.959-.77-5.608-7.9-7.344-10.578-1.192,1.849-5.976,5.193-6.7,5.689l-.975,5.312,1.507,1.829a18.945,18.945,0,0,1,2.532,4.333l8.22-3.5a.26.26,0,0,1,.163-.008,23,23,0,0,1,9.568,6.376,13.738,13.738,0,0,1,3.55,9.523.243.243,0,0,1-.113.179c-.12.077-12.283,7.7-19.89,9.378a65.345,65.345,0,0,1-13.106,1.183m-.236-64.544a9.553,9.553,0,0,0-6.038,1.849,37,37,0,0,0-6.664,15.052A129.322,129.322,0,0,0,25.13,96.476c-.066,1.162-.113,2-.167,2.409-.077.6-.369,2.019-.737,3.81-.675,3.281-1.6,7.774-1.965,10.822-.563,4.73,4.562,9.36,7.3,10.675,2.991,1.441,15.922,1.674,23.6-.015,7.15-1.58,18.427-8.5,19.63-9.253a13.623,13.623,0,0,0-3.44-9.049,22.508,22.508,0,0,0-9.261-6.2l-8.361,3.565a.253.253,0,0,1-.187,0,.248.248,0,0,1-.132-.132,18.96,18.96,0,0,0-2.551-4.439L47.28,96.752a.25.25,0,0,1-.051-.194l1.014-5.518a.233.233,0,0,1,.1-.155c.062-.044,6.034-4.143,6.784-5.864a.3.3,0,0,1,.217-.172c.09,0,.191.008.234.079,3.115,4.83,6.711,10.2,7.463,10.81,1.021.816,4.264.964,5.65-.326,1.41-1.3,2.043-2.127,1.732-4.035-.19-.408-2.295-4.909-3.464-6.927a63.32,63.32,0,0,1-2.575-5.921,67.283,67.283,0,0,0-2.718-6.237c-.393-.692-.688-1.29-.951-1.818a9.1,9.1,0,0,0-1.068-1.833,13.307,13.307,0,0,0-1.663-2.275c-.927-1-3.087-1.458-4.516-1.76a8.473,8.473,0,0,1-1.254-.318l-.21-.09a42.829,42.829,0,0,0-5.173-1.7,24.827,24.827,0,0,0-6.916-1.213m33.1,53.78h0Z",
    transform: "translate(6.15 7.857)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276590",
    "data-name": "Path 276590",
    d: "M42.077,78.272h-.008l-1.541-.051a.241.241,0,0,1,.007-.481h.008l1.542.051a.241.241,0,0,1-.008.481",
    transform: "translate(13.699 14.747)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276591",
    "data-name": "Path 276591",
    d: "M47.523,79.166h-.008L43.55,79.03a.241.241,0,0,1,.008-.481h.007l2.85.1A43.262,43.262,0,0,0,41.143,76.5a.244.244,0,0,1-.155-.3.227.227,0,0,1,.3-.155,47.662,47.662,0,0,1,6.345,2.672.247.247,0,0,1,.121.276.242.242,0,0,1-.234.179",
    transform: "translate(13.977 14.05)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276592",
    "data-name": "Path 276592",
    d: "M56.042,78.221a5.246,5.246,0,0,1,.8,2.31c0,1.066.179,2.489-.266,2.044a4.714,4.714,0,0,1-.622-1.956Z",
    transform: "translate(20.07 14.942)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276593",
    "data-name": "Path 276593",
    d: "M56.782,82.971a.448.448,0,0,1-.311-.155,4.69,4.69,0,0,1-.687-2.1l.086-2.434a.242.242,0,0,1,.179-.225.281.281,0,0,1,.263.1,5.4,5.4,0,0,1,.838,2.44c0,.241.008.5.015.748.035,1.014.039,1.465-.256,1.6a.313.313,0,0,1-.128.027m-.466-3.77-.055,1.5a5.48,5.48,0,0,0,.435,1.619c.017-.26,0-.657-.007-.952-.011-.256-.02-.519-.02-.764a3.671,3.671,0,0,0-.353-1.4",
    transform: "translate(20.001 14.874)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276594",
    "data-name": "Path 276594",
    d: "M54.121,77.439s1.669-.9,2.392.183a5.2,5.2,0,0,1,0,4.34c-.543,1.085-1.163.048-1.085-.9s-1.307-3.618-1.307-3.618",
    transform: "translate(19.324 14.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276595",
    "data-name": "Path 276595",
    d: "M56.089,82.735a.492.492,0,0,1-.144-.02c-.494-.139-.741-.943-.688-1.607a11.3,11.3,0,0,0-1.282-3.488.244.244,0,0,1,.1-.326c.075-.035,1.873-.986,2.707.264a5.414,5.414,0,0,1,.011,4.582c-.241.485-.512.594-.706.594m-1.573-5.114a10.44,10.44,0,0,1,1.223,3.526,1.261,1.261,0,0,0,.339,1.107h.007c.051,0,.159-.086.284-.331a4.983,4.983,0,0,0,.011-4.1c-.45-.684-1.429-.385-1.864-.2",
    transform: "translate(19.254 14.411)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276596",
    "data-name": "Path 276596",
    d: "M53.679,76.618s1.669-.9,2.392.183a5.2,5.2,0,0,1,0,4.34c-.543,1.085-1.163.048-1.085-.9s-1.307-3.618-1.307-3.618",
    transform: "translate(19.145 14.147)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276597",
    "data-name": "Path 276597",
    d: "M55.648,81.917a.654.654,0,0,1-.143-.02c-.5-.139-.746-.943-.692-1.611A11.273,11.273,0,0,0,53.535,76.8a.238.238,0,0,1,.1-.322c.075-.042,1.868-1,2.707.26a5.434,5.434,0,0,1,.011,4.578c-.241.485-.512.6-.706.6M54.075,76.8a10.419,10.419,0,0,1,1.22,3.523c-.046.582.19,1.068.338,1.106l.011,0c.051,0,.159-.086.284-.333a4.961,4.961,0,0,0,.011-4.1c-.45-.681-1.429-.381-1.864-.2",
    transform: "translate(19.075 14.076)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276598",
    "data-name": "Path 276598",
    d: "M53.136,75.734s1.669-.9,2.392.183a5.2,5.2,0,0,1,0,4.34c-.543,1.085-1.163.048-1.085-.9s-1.307-3.618-1.307-3.618",
    transform: "translate(18.924 13.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276599",
    "data-name": "Path 276599",
    d: "M55.1,81.03a.491.491,0,0,1-.144-.02c-.494-.139-.741-.943-.688-1.607a11.3,11.3,0,0,0-1.282-3.488.244.244,0,0,1,.1-.326c.075-.035,1.873-.99,2.707.264a5.388,5.388,0,0,1,.011,4.582c-.241.485-.512.594-.706.594m-1.573-5.114a10.44,10.44,0,0,1,1.223,3.526,1.261,1.261,0,0,0,.339,1.107H55.1c.051,0,.159-.086.284-.331a4.983,4.983,0,0,0,.011-4.1c-.45-.681-1.429-.381-1.864-.2",
    transform: "translate(18.853 13.716)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276600",
    "data-name": "Path 276600",
    d: "M58.506,46.2a9.506,9.506,0,0,1-1.29,4.925c-2.461,3.765-4.778,3.33-5.792,6.372s-2.462,6.227-.868,7.964,2.9.725,2.9.725,1.014,2.606-1.593,5.212-7.095,1.593-8.254,1.158A7.818,7.818,0,0,1,41.577,71.4s-.725,2.027-4.344,2.027-7.674-2.462-7.674-6.951,2.462-7.53,3.04-9.267-1.013-7.1,1.449-10.426,6.227-5.792,9.122-5.792,8.521,1.58,8.544,1.593c.381.205,2.814-.784,3.471-.741C57.594,42,58.476,44,58.506,46.2",
    transform: "translate(9.331 -0.206)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276601",
    "data-name": "Path 276601",
    d: "M37.3,73.734c-3.891,0-7.919-2.689-7.919-7.189A15.973,15.973,0,0,1,31.65,58.88a12.965,12.965,0,0,0,.788-1.683,8.977,8.977,0,0,0,.073-2.667c-.115-2.338-.276-5.542,1.41-7.825,2.568-3.464,6.4-5.886,9.32-5.886,2.963,0,8.617,1.6,8.652,1.619a6.522,6.522,0,0,0,1.611-.377,8.067,8.067,0,0,1,1.709-.393h.053c2.219.148,3.512,1.822,3.55,4.6a9.8,9.8,0,0,1-1.328,5.06,11.964,11.964,0,0,1-3.378,3.429,5.377,5.377,0,0,0-2.389,2.89c-.135.4-.276.8-.415,1.207-.92,2.629-1.79,5.115-.505,6.517,1.425,1.546,2.528.737,2.57.695a.243.243,0,0,1,.214-.039.234.234,0,0,1,.159.145c.044.108,1.037,2.78-1.646,5.467-2.617,2.614-7.133,1.732-8.509,1.216a8.269,8.269,0,0,1-1.86-1.017c-.357.594-1.472,1.9-4.426,1.9M43.241,41.3c-2.78,0-6.455,2.341-8.932,5.694-1.584,2.143-1.428,5.249-1.315,7.514a9.075,9.075,0,0,1-.1,2.846,13.618,13.618,0,0,1-.82,1.747,15.578,15.578,0,0,0-2.209,7.444c0,4.2,3.782,6.707,7.437,6.707,3.386,0,4.088-1.79,4.115-1.867a.257.257,0,0,1,.163-.152.293.293,0,0,1,.218.046A7.587,7.587,0,0,0,43.762,72.4c1.3.49,5.561,1.335,8-1.107a4.929,4.929,0,0,0,1.615-4.688c-.508.229-1.653.47-2.928-.912-1.479-1.615-.521-4.353.408-7,.139-.4.28-.8.412-1.2a5.857,5.857,0,0,1,2.562-3.122,11.532,11.532,0,0,0,3.258-3.3,9.244,9.244,0,0,0,1.251-4.788c-.02-1.465-.45-3.949-3.1-4.125a7.293,7.293,0,0,0-1.6.373c-1.189.355-1.712.467-1.97.342-.011,0-5.564-1.564-8.43-1.564",
    transform: "translate(9.26 -0.275)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276602",
    "data-name": "Path 276602",
    d: "M44.339,59.7a5.759,5.759,0,0,1-.858-.062.24.24,0,0,1,.035-.478.1.1,0,0,1,.035,0,6.146,6.146,0,0,0,1.518.011.212.212,0,0,1,.264.21.236.236,0,0,1-.21.264,5.931,5.931,0,0,1-.785.051",
    transform: "translate(14.912 7.188)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276603",
    "data-name": "Path 276603",
    d: "M42.511,64.116a.23.23,0,0,1-.139-.046,3.3,3.3,0,0,1-1.418-2.345,4.563,4.563,0,0,1,1.387-3.507,43.042,43.042,0,0,1,3.42-3.309,21.865,21.865,0,0,0,4.423-4.845,9.87,9.87,0,0,0,1.367-3.545.233.233,0,0,1,.28-.194.239.239,0,0,1,.194.279,10.3,10.3,0,0,1-1.438,3.717,22.571,22.571,0,0,1-4.5,4.951A41.713,41.713,0,0,0,42.7,58.544a4.1,4.1,0,0,0-1.265,3.13,2.833,2.833,0,0,0,1.218,2.008.24.24,0,0,1-.139.435",
    transform: "translate(13.959 1.961)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276604",
    "data-name": "Path 276604",
    d: "M48.889,45.734a.24.24,0,0,1-.241-.241,8.493,8.493,0,0,0-.136-1.557.244.244,0,0,1,.187-.287c.02,0,.035,0,.051,0a.243.243,0,0,1,.236.19,9.338,9.338,0,0,1,.144,1.659.239.239,0,0,1-.241.241",
    transform: "translate(17.041 0.874)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276605",
    "data-name": "Path 276605",
    d: "M40.418,61.783a.242.242,0,0,1-.241-.229c-.106-2.015,1.529-3.343,3.261-4.75a15.717,15.717,0,0,0,2.89-2.791c2.023-2.8,2.52-7.7,2.524-7.752a.241.241,0,0,1,.241-.217h.024a.246.246,0,0,1,.218.263c-.024.207-.518,5.076-2.618,7.984a15.828,15.828,0,0,1-2.974,2.885c-1.705,1.387-3.177,2.583-3.084,4.354a.242.242,0,0,1-.229.252Z",
    transform: "translate(13.649 1.851)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276606",
    "data-name": "Path 276606",
    d: "M63.775,108.416s3,15.416,5.567,22.912,5.139,14.346,5.782,14.989,2.355,3,2.355,3a4.956,4.956,0,0,1-2.784,1.071c-1.5,0-3.426-1.926-5.139-3s-1.926-1.714-5.353-3-.642-4.712.215-6.424a7.408,7.408,0,0,0,.855-3,33.9,33.9,0,0,0-7.065-13.061c-5.353-6-6.424-19.914-6.424-19.914l10.277-3.855Z",
    transform: "translate(18.374 23.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276607",
    "data-name": "Path 276607",
    d: "M74.766,150.694c-1.125,0-2.434-.975-3.7-1.922-.525-.388-1.065-.8-1.573-1.114-.49-.3-.855-.575-1.208-.836a14.054,14.054,0,0,0-4.1-2.14,2.613,2.613,0,0,1-1.692-1.507c-.481-1.351.49-3.014,1.269-4.344.194-.335.377-.642.509-.906a7.224,7.224,0,0,0,.827-2.888,34.223,34.223,0,0,0-7-12.9c-5.348-5.989-6.438-19.484-6.484-20.053a.238.238,0,0,1,.155-.245l10.276-3.852A.234.234,0,0,1,62.25,98a.248.248,0,0,1,.117.17l1.712,10.276c.058.291,3.037,15.518,5.561,22.876,2.819,8.225,5.176,14.349,5.723,14.893.646.653,2.307,2.932,2.378,3.029a.237.237,0,0,1-.039.322,5.135,5.135,0,0,1-2.936,1.13M52.111,102.219c.148,1.646,1.434,14.093,6.345,19.595a34.444,34.444,0,0,1,7.119,13.164,7.366,7.366,0,0,1-.874,3.165c-.136.272-.319.587-.521.929-.691,1.185-1.639,2.8-1.235,3.945a2.148,2.148,0,0,0,1.414,1.216,14.43,14.43,0,0,1,4.214,2.206c.349.252.706.516,1.18.816.523.325,1.075.737,1.6,1.134,1.2.9,2.442,1.825,3.409,1.825a4.508,4.508,0,0,0,2.447-.882c-.419-.57-1.673-2.259-2.19-2.776-.958-.955-5.032-12.729-5.84-15.079-2.544-7.425-5.546-22.787-5.577-22.943v-.007l-1.666-9.992Z",
    transform: "translate(18.304 22.976)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276608",
    "data-name": "Path 276608",
    d: "M71.564,134.031l-.62.124s-3.64-4.924-6.424-6.638a6.109,6.109,0,0,0-3.212-1.069c-.858,1.714-3.64,5.138-.214,6.422s3.64,1.927,5.353,3,3.64,3,5.139,3a4.955,4.955,0,0,0,2.783-1.071s-1.712-2.357-2.355-3a3.464,3.464,0,0,1-.45-.767",
    transform: "translate(21.484 34.564)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276609",
    "data-name": "Path 276609",
    d: "M71.656,139.176c-1.125,0-2.434-.974-3.7-1.922-.523-.388-1.064-.8-1.571-1.114-.49-.3-.855-.575-1.208-.834a13.983,13.983,0,0,0-4.1-2.14,2.62,2.62,0,0,1-1.692-1.507c-.481-1.352.49-3.014,1.269-4.346.194-.333.377-.64.509-.9a.232.232,0,0,1,.234-.132,6.469,6.469,0,0,1,3.32,1.107c2.577,1.588,5.8,5.785,6.4,6.577l.474-.1a.231.231,0,0,1,.263.132,2.838,2.838,0,0,0,.4.695c.649.657,2.31,2.936,2.38,3.033a.242.242,0,0,1-.039.326,5.175,5.175,0,0,1-2.936,1.126M61.521,126.761c-.124.236-.283.505-.45.792-.692,1.185-1.639,2.8-1.235,3.945a2.145,2.145,0,0,0,1.414,1.216,14.5,14.5,0,0,1,4.214,2.206c.349.253.706.516,1.18.816.523.326,1.075.737,1.6,1.134,1.2.9,2.442,1.825,3.409,1.825a4.52,4.52,0,0,0,2.447-.881c-.419-.571-1.673-2.261-2.19-2.777a2.59,2.59,0,0,1-.411-.664l-.443.09a.217.217,0,0,1-.241-.094c-.035-.051-3.642-4.909-6.353-6.574a6.107,6.107,0,0,0-2.943-1.033",
    transform: "translate(21.414 34.494)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276610",
    "data-name": "Path 276610",
    d: "M69.827,136.822c-1.7-1.171-3.222-3.768-5.978-5.388-2.506-1.473-3.792-1.526-4.353-1.417a2.331,2.331,0,0,0,1.569,1.417c3.429,1.286,3.642,1.927,5.353,3,1.1.691,2.3,1.733,3.409,2.39",
    transform: "translate(21.511 36.001)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276611",
    "data-name": "Path 276611",
    d: "M69.9,137.133a.252.252,0,0,1-.125-.035,21.856,21.856,0,0,1-1.833-1.275c-.523-.4-1.068-.8-1.58-1.118-.49-.307-.854-.578-1.207-.839a14.074,14.074,0,0,0-4.1-2.14,2.585,2.585,0,0,1-1.714-1.569.259.259,0,0,1,.024-.2.252.252,0,0,1,.159-.113c.734-.128,2.07.008,4.52,1.449a17.417,17.417,0,0,1,3.931,3.429,13.912,13.912,0,0,0,2.061,1.97.241.241,0,0,1-.135.439m-9.985-6.843a2.346,2.346,0,0,0,1.308.986,14.41,14.41,0,0,1,4.214,2.206c.349.252.706.516,1.18.816.264.162.536.349.8.543a16.154,16.154,0,0,0-3.62-3.135,8.16,8.16,0,0,0-3.821-1.417Z",
    transform: "translate(21.443 35.932)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276612",
    "data-name": "Path 276612",
    d: "M68.164,135.284a2.471,2.471,0,0,1-.325-.031,2,2,0,0,0,.325.031",
    transform: "translate(24.906 38.147)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276613",
    "data-name": "Path 276613",
    d: "M68.235,135.594a1.924,1.924,0,0,1-.369-.035.237.237,0,0,1-.194-.276.24.24,0,0,1,.236-.2.149.149,0,0,1,.035,0,1.957,1.957,0,0,0,.291.028.241.241,0,1,1,0,.481",
    transform: "translate(24.836 38.077)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276614",
    "data-name": "Path 276614",
    d: "M46.865,89.52s10.29-3.647,11.252-1.241,5.367,11.372,3.763,15.059-12.9-10.571-14.5-10.892-.7-1.846-.511-2.926",
    transform: "translate(16.199 18.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276615",
    "data-name": "Path 276615",
    d: "M61.062,104.252c-2.089,0-6.283-4.306-9.682-7.794-1.732-1.774-3.521-3.616-3.984-3.7a1.372,1.372,0,0,1-.958-.587,2.476,2.476,0,0,1,.077-1.911c.073-.252.144-.494.183-.71a.232.232,0,0,1,.155-.183c1.076-.384,10.523-3.662,11.556-1.106.132.329.331.788.567,1.335,1.5,3.452,4.617,10.636,3.2,13.91a1.151,1.151,0,0,1-.869.73,1.235,1.235,0,0,1-.241.02M47.144,89.771c-.042.2-.106.412-.167.618-.166.578-.342,1.18-.128,1.529a.908.908,0,0,0,.642.362c.578.117,1.851,1.4,4.232,3.845,2.991,3.067,7.456,7.649,9.316,7.649a.768.768,0,0,0,.174-.015.671.671,0,0,0,.516-.45c1.341-3.08-1.719-10.131-3.195-13.521-.241-.556-.439-1.017-.575-1.352-.613-1.571-6.9-.031-10.815,1.337",
    transform: "translate(16.13 18.632)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276616",
    "data-name": "Path 276616",
    d: "M56.664,92.332s11.7-.962,13.948,1.123-5.45,27.093-9.619,34.948c-6.518,12.283-4.558,15.492-4.558,15.492s.481,1.925,3.687,4.97,4.169,3.527,3.046,4.008-5.931,0-6.412-.321-4.008-3.206-7.214-4.169-2.725-1.6-1.283-4.489,1.283-.481,2.887-5.45a146.766,146.766,0,0,0,4.539-18.687c.848-5.151,2.151-10.806,1.783-16.043l-.8-11.383",
    transform: "translate(16.486 20.593)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276617",
    "data-name": "Path 276617",
    d: "M61.336,153.384a15.64,15.64,0,0,1-4.641-.56c-.069-.051-.205-.148-.388-.287a24.774,24.774,0,0,0-6.764-3.856c-1.553-.463-2.221-.851-2.47-1.421-.307-.715.132-1.6.867-3.053l.174-.349a5.519,5.519,0,0,1,1.22-1.8c.4-.384.706-.687,1.654-3.623a146.356,146.356,0,0,0,4.532-18.651c.155-.959.329-1.934.505-2.921.772-4.342,1.569-8.835,1.269-13.071l-.8-11.382a.243.243,0,0,1,.221-.256c.485-.032,11.836-.948,14.132,1.187,2.5,2.327-5.588,27.731-9.57,35.238-6.329,11.922-4.582,15.227-4.567,15.257a.175.175,0,0,1,.028.066c0,.018.519,1.906,3.618,4.849.672.642,1.246,1.169,1.725,1.6,1.4,1.286,1.922,1.763,1.84,2.237-.051.3-.342.459-.591.563a6.115,6.115,0,0,1-1.995.222M56.99,92.622l.785,11.145c.3,4.3-.5,8.815-1.279,13.188-.174.982-.345,1.957-.5,2.912a147.286,147.286,0,0,1-4.548,18.721c-.986,3.053-1.335,3.391-1.778,3.821a5.191,5.191,0,0,0-1.125,1.666l-.174.35c-.668,1.331-1.072,2.136-.851,2.643.174.412.8.746,2.167,1.154a25.037,25.037,0,0,1,6.912,3.931c.176.131.3.225.366.272.428.267,5.149.733,6.186.3.276-.117.3-.187.3-.2.035-.214-.726-.913-1.692-1.8-.478-.439-1.057-.971-1.732-1.612-3.029-2.881-3.662-4.772-3.744-5.052-.205-.4-1.666-3.949,4.571-15.7,4.508-8.5,11.677-32.8,9.669-34.662-1.974-1.829-11.871-1.193-13.53-1.076",
    transform: "translate(16.416 20.523)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276618",
    "data-name": "Path 276618",
    d: "M75.5,101.732a15.562,15.562,0,0,0-6.037-7.178c-5.117-3.263-9.457-6.3-9.457-6.3l-8.444,3.6s2.061,3.492-8.52,5.256c-8.15,1.358-15.629-.612-19.664-2.981-.561,2.791-1.152,5.9-1.424,8.195-.564,4.728,4.389,9.456,7.43,10.92s27.53,4.5,34.125.266C75.5,105.8,75.5,101.732,75.5,101.732",
    transform: "translate(6.22 19.023)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276619",
    "data-name": "Path 276619",
    d: "M50.635,115.993c-9.157,0-19.494-1.6-21.284-2.461-2.842-1.372-8.158-6.2-7.565-11.165.287-2.4.913-5.654,1.425-8.218a.245.245,0,0,1,.141-.174.249.249,0,0,1,.217.015c3.8,2.226,11.187,4.333,19.506,2.952,5.926-.986,7.786-2.493,8.306-3.58a1.464,1.464,0,0,0,.042-1.321.265.265,0,0,1-.018-.2.244.244,0,0,1,.135-.145l8.443-3.6a.24.24,0,0,1,.234.023c.042.031,4.4,3.075,9.443,6.3a15.66,15.66,0,0,1,6.137,7.3.183.183,0,0,1,.015.079c0,.17-.136,4.287-12.1,11.975-2.551,1.643-7.6,2.213-13.071,2.213M23.619,94.573c-.5,2.5-1.083,5.564-1.359,7.848-.563,4.73,4.562,9.36,7.3,10.675,2.773,1.341,27.366,4.47,33.89.28,11.066-7.115,11.825-11.114,11.875-11.538A15.564,15.564,0,0,0,69.4,94.825c-4.617-2.943-8.648-5.739-9.354-6.232l-8.1,3.457a2.062,2.062,0,0,1-.124,1.5c-.56,1.2-2.517,2.843-8.672,3.867-8.236,1.372-15.588-.632-19.533-2.842",
    transform: "translate(6.15 18.953)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276620",
    "data-name": "Path 276620",
    d: "M50.307,92.8c-1.128.924-3.336,1.9-7.563,2.61-8.15,1.358-15.629-.612-19.664-2.981-.143.715-.29,1.45-.431,2.189,2.763,1.662,8.572,4.482,15.124,3.678,7.815-.959,11.29-3.092,12.534-5.5",
    transform: "translate(6.52 20.723)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276621",
    "data-name": "Path 276621",
    d: "M35.5,98.744a25.9,25.9,0,0,1-12.908-3.852.241.241,0,0,1-.113-.253c.144-.737.287-1.474.432-2.189a.242.242,0,0,1,.139-.176.252.252,0,0,1,.218.017c3.8,2.224,11.187,4.333,19.5,2.95,3.6-.6,6.113-1.463,7.452-2.559a.242.242,0,0,1,.366.3C49.1,95.859,44.821,97.749,37.874,98.6a18.974,18.974,0,0,1-2.373.143M22.985,94.566c2.877,1.705,8.512,4.315,14.827,3.561,5.937-.73,9.859-2.206,11.7-4.392a21.694,21.694,0,0,1-6.656,1.981c-8.236,1.37-15.587-.633-19.533-2.846-.113.559-.221,1.125-.333,1.7",
    transform: "translate(6.449 20.653)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276622",
    "data-name": "Path 276622",
    d: "M37.116,101.773a.253.253,0,0,1-.155-.055.247.247,0,0,1-.032-.342c.4-.473.779-.955,1.158-1.443a.236.236,0,0,1,.336-.044.242.242,0,0,1,.045.338c-.378.49-.771.979-1.166,1.46a.251.251,0,0,1-.186.086",
    transform: "translate(12.308 23.737)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276623",
    "data-name": "Path 276623",
    d: "M38.613,101.69a.23.23,0,0,1-.139-.046.238.238,0,0,1-.055-.335,74.248,74.248,0,0,0,4.928-7.832.248.248,0,0,1,.326-.1.243.243,0,0,1,.1.326,73.98,73.98,0,0,1-4.966,7.887.238.238,0,0,1-.194.1",
    transform: "translate(12.917 21.098)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276624",
    "data-name": "Path 276624",
    d: "M35.406,102.09a.241.241,0,0,1-.143-.435,34.782,34.782,0,0,0,5.879-6.042.25.25,0,0,1,.338-.051.243.243,0,0,1,.051.338,35.665,35.665,0,0,1-5.981,6.144.243.243,0,0,1-.143.046",
    transform: "translate(11.612 21.98)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276625",
    "data-name": "Path 276625",
    d: "M60.121,134.575c-3.206-3.046-3.687-4.97-3.687-4.97a1.03,1.03,0,0,1-.253-.359c-.217.229-.869.656-2.472.039-1.39-.535-2.708-1.424-4.1-2.053-.331.589-.653.971-1.353,2.372-1.443,2.887-1.925,3.527,1.282,4.489s6.733,3.848,7.214,4.169,5.29.8,6.413.321.16-.962-3.046-4.008",
    transform: "translate(16.485 34.884)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276626",
    "data-name": "Path 276626",
    d: "M61.334,139.094a15.641,15.641,0,0,1-4.64-.559c-.07-.051-.205-.148-.388-.288a24.831,24.831,0,0,0-6.764-3.856c-1.553-.461-2.221-.85-2.47-1.421-.307-.715.132-1.6.867-3.051l.174-.35a19.231,19.231,0,0,1,1.037-1.851c.117-.183.217-.346.322-.533a.235.235,0,0,1,.311-.1c.609.276,1.207.6,1.79.92a19.618,19.618,0,0,0,2.292,1.125c1.479.575,2.039.207,2.213.02a.192.192,0,0,1,.214-.07.247.247,0,0,1,.179.132.886.886,0,0,0,.183.276.272.272,0,0,1,.084.132c0,.02.521,1.906,3.62,4.851.671.64,1.246,1.168,1.723,1.6,1.4,1.284,1.923,1.763,1.842,2.236-.051.3-.342.459-.591.564a6.127,6.127,0,0,1-2,.221M49.778,127.611c-.07.121-.143.236-.221.362a19.478,19.478,0,0,0-1.019,1.813l-.174.349c-.667,1.332-1.072,2.136-.85,2.645.174.411.8.746,2.167,1.154a25.04,25.04,0,0,1,6.912,3.929c.174.132.3.225.366.272.426.269,5.149.734,6.186.3.276-.117.3-.186.3-.2.035-.214-.726-.913-1.692-1.8-.478-.439-1.057-.972-1.732-1.612-2.914-2.769-3.613-4.624-3.732-5.01a1.224,1.224,0,0,1-.106-.132,2.762,2.762,0,0,1-2.493-.1,20.628,20.628,0,0,1-2.349-1.152c-.512-.28-1.037-.567-1.564-.816",
    transform: "translate(16.416 34.813)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276627",
    "data-name": "Path 276627",
    d: "M58.538,100.275a.247.247,0,0,1-.205-.113.242.242,0,0,1,.077-.333l5.452-3.368a.25.25,0,0,1,.335.079.243.243,0,0,1-.079.333l-5.452,3.367a.259.259,0,0,1-.128.035",
    transform: "translate(21.023 22.35)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276628",
    "data-name": "Path 276628",
    d: "M12.155,77.535s17.375-2.172,28.474.965l1.69,42.228H16.257s1.688-22.683-4.1-43.194",
    transform: "translate(2.25 14.365)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276629",
    "data-name": "Path 276629",
    d: "M42.389,121.037H16.328a.227.227,0,0,1-.174-.077.231.231,0,0,1-.066-.183c.018-.225,1.619-22.876-4.1-43.108a.235.235,0,0,1,.031-.2.232.232,0,0,1,.17-.1c.174-.032,17.545-2.148,28.573.971a.244.244,0,0,1,.174.225l1.69,42.227a.238.238,0,0,1-.241.248m-25.8-.481H42.14l-1.674-41.8c-10.166-2.812-25.671-1.2-27.936-.948,5.325,19.079,4.214,40.18,4.055,42.748",
    transform: "translate(2.179 14.297)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276630",
    "data-name": "Path 276630",
    d: "M40.629,78.5c-11.1-3.137-28.474-.965-28.474-.965a116.9,116.9,0,0,1,3.69,20.884,104.137,104.137,0,0,1,26.33,18.737Z",
    transform: "translate(2.25 14.365)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276631",
    "data-name": "Path 276631",
    d: "M42.245,117.465a.22.22,0,0,1-.166-.07A103.371,103.371,0,0,0,15.808,98.7a.236.236,0,0,1-.132-.19,115.782,115.782,0,0,0-3.685-20.841.234.234,0,0,1,.031-.2.238.238,0,0,1,.17-.106c.174-.031,17.545-2.147,28.573.972a.24.24,0,0,1,.174.225l1.546,38.654a.247.247,0,0,1-.142.229.306.306,0,0,1-.1.02m-26.1-19.133a103.739,103.739,0,0,1,25.837,18.3L40.467,78.756c-10.167-2.812-25.674-1.2-27.938-.948a117.022,117.022,0,0,1,3.616,20.523",
    transform: "translate(2.179 14.297)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276632",
    "data-name": "Path 276632",
    d: "M57.346,147.7a.962.962,0,0,1-.9-.627c-3.858-10.367-4.83-37.283-4.869-38.424a.962.962,0,0,1,1.923-.068c.008.277,1,27.746,4.75,37.822a.963.963,0,0,1-.9,1.3",
    transform: "translate(18.288 26.917)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276633",
    "data-name": "Path 276633",
    d: "M57.416,148.008a1.186,1.186,0,0,1-1.125-.785c-3.891-10.446-4.847-37.357-4.886-38.5a1.192,1.192,0,0,1,1.162-1.242h.046a1.205,1.205,0,0,1,1.2,1.161c.007.272.995,27.689,4.734,37.742a1.2,1.2,0,0,1-1.127,1.624m-4.807-40.045h-.027a.7.7,0,0,0-.5.225.71.71,0,0,0-.194.521c.038,1.138.989,27.971,4.854,38.347a.74.74,0,0,0,.929.428.727.727,0,0,0,.4-.377.715.715,0,0,0,.018-.551c-3.766-10.124-4.757-37.625-4.764-37.9a.734.734,0,0,0-.229-.5.7.7,0,0,0-.49-.194",
    transform: "translate(18.219 26.848)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276634",
    "data-name": "Path 276634",
    d: "M42.46,147.7a.962.962,0,0,1-.9-.627c-3.858-10.367-4.83-37.283-4.869-38.424a.962.962,0,0,1,1.923-.068c.008.277,1,27.746,4.75,37.822a.963.963,0,0,1-.9,1.3",
    transform: "translate(12.232 26.917)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276635",
    "data-name": "Path 276635",
    d: "M42.53,148.008a1.186,1.186,0,0,1-1.125-.785c-3.891-10.446-4.847-37.357-4.886-38.5a1.192,1.192,0,0,1,1.162-1.242,1.236,1.236,0,0,1,.858.322,1.187,1.187,0,0,1,.384.838c.007.272.995,27.689,4.734,37.742a1.2,1.2,0,0,1-1.127,1.624m-4.807-40.045H37.7a.7.7,0,0,0-.5.225.71.71,0,0,0-.194.521c.038,1.138.989,27.971,4.854,38.347a.738.738,0,0,0,.929.428.727.727,0,0,0,.4-.377.715.715,0,0,0,.018-.551c-3.766-10.124-4.757-37.625-4.764-37.9a.734.734,0,0,0-.229-.5.7.7,0,0,0-.49-.194",
    transform: "translate(12.162 26.847)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276636",
    "data-name": "Path 276636",
    d: "M72.067,108.565H14.755v-1.911h55.4a1.912,1.912,0,0,1,1.912,1.911",
    transform: "translate(3.308 26.511)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276637",
    "data-name": "Path 276637",
    d: "M72.137,108.874H14.824a.241.241,0,0,1-.241-.241v-1.911a.241.241,0,0,1,.241-.241h55.4a2.156,2.156,0,0,1,2.151,2.151.241.241,0,0,1-.241.241m-57.072-.481H71.88a1.674,1.674,0,0,0-1.654-1.429H15.064Z",
    transform: "translate(3.238 26.441)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25548",
    "data-name": "Rectangle 25548",
    width: 57.312,
    height: 1.911,
    transform: "translate(18.061 134.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276638",
    "data-name": "Path 276638",
    d: "M72.137,109.9H14.824a.241.241,0,0,1-.241-.241V107.75a.241.241,0,0,1,.241-.241H72.137a.241.241,0,0,1,.241.241v1.911a.241.241,0,0,1-.241.241m-57.072-.481H71.9V107.99H15.064Z",
    transform: "translate(3.238 26.859)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276639",
    "data-name": "Path 276639",
    d: "M32.368,160.037a.975.975,0,0,1-.2-.021.962.962,0,0,1-.743-1.14c5.438-25.768.464-79.955.414-80.5a.962.962,0,0,1,1.916-.179c.051.547,5.051,55.023-.447,81.076a.963.963,0,0,1-.94.763",
    transform: "translate(10.082 14.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276640",
    "data-name": "Path 276640",
    d: "M32.436,160.348a.965.965,0,0,1-.253-.027,1.205,1.205,0,0,1-.924-1.425c5.411-25.622.459-79.879.408-80.424a1.218,1.218,0,0,1,1.087-1.313,1.136,1.136,0,0,1,.878.273,1.2,1.2,0,0,1,.435.815c.051.551,5.03,55.159-.45,81.149a1.216,1.216,0,0,1-1.18.951m.435-82.71a.392.392,0,0,0-.07,0,.723.723,0,0,0-.651.788c.049.544,5.006,54.875-.416,80.567a.722.722,0,0,0,.556.854.553.553,0,0,0,.148.015.725.725,0,0,0,.706-.571c5.468-25.916.494-80.453.443-81a.693.693,0,0,0-.26-.488.709.709,0,0,0-.454-.167",
    transform: "translate(10.012 14.506)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276641",
    "data-name": "Path 276641",
    d: "M11.172,159.6a.941.941,0,0,1-.262-.037.962.962,0,0,1-.664-1.187c12.514-44.391,1.889-80.132,1.78-80.488a.962.962,0,0,1,1.84-.563c.111.36,10.906,36.612-1.768,81.574a.964.964,0,0,1-.926.7",
    transform: "translate(1.459 14.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276642",
    "data-name": "Path 276642",
    d: "M11.244,159.908a1.064,1.064,0,0,1-.333-.051,1.2,1.2,0,0,1-.827-1.483c12.477-44.243,1.9-80,1.787-80.353a1.218,1.218,0,0,1,.084-.917,1.2,1.2,0,0,1,.712-.582,1.161,1.161,0,0,1,.912.09,1.176,1.176,0,0,1,.587.706c.113.357,11.024,36.348-1.763,81.712a1.214,1.214,0,0,1-1.158.878m1.771-82.959a.772.772,0,0,0-.21.031.723.723,0,0,0-.478.9c.11.357,10.734,36.248-1.778,80.626a.721.721,0,0,0,1.387.391c12.752-45.224,1.882-81.082,1.77-81.439a.713.713,0,0,0-.353-.423.681.681,0,0,0-.338-.086",
    transform: "translate(1.389 14.229)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276643",
    "data-name": "Path 276643",
    d: "M130.423,140.059h-.011a.484.484,0,0,1-.47-.494c.011-.481,1.1-48.482,1.529-55.848.148-2.5.917-4.145,2.281-4.893,2.07-1.147,4.675.276,4.788.342a.477.477,0,0,1,.186.651.472.472,0,0,1-.651.187c-.024-.011-2.276-1.224-3.86-.338-1.057.582-1.654,1.964-1.778,4.1-.432,7.351-1.518,55.333-1.531,55.819a.483.483,0,0,1-.481.47",
    transform: "translate(50.173 15.006)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276644",
    "data-name": "Path 276644",
    d: "M131.963,137.8h-.024a.486.486,0,0,1-.457-.505c2.151-43.054-2.544-54.2-2.59-54.3a.477.477,0,0,1,.245-.633.486.486,0,0,1,.632.241c.2.443,4.842,11.335,2.676,54.743a.485.485,0,0,1-.481.459",
    transform: "translate(49.729 16.61)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276645",
    "data-name": "Path 276645",
    d: "M137.547,82.222s-2.261,1.449-3.548-.21.871-4.7-1.031-5.995-5.183.684-5.183.684,2.528.741,2.447,2.122-1.3,1.9-1.462,1.3-1.367-3.641-3.42-2.378a5.085,5.085,0,0,0-2.366,3.223s4.778-.509,5.068,1.289-1.96-.314-3.931-.43-3.769.173-3.641,1.367a15.591,15.591,0,0,1-.187,3.154,5.868,5.868,0,0,1,3.839-1.356c2.168.128,2.086,1.508.115,1.391s-3.665,1.763-3.665,1.763a16.287,16.287,0,0,0,4.081,4.592c2.283,1.519,3.108.975,3.374-.2s-.346-4.174,1.033-4.093-2.285,5.205-.522,5.508,3.177-.208,3.641-1.367l.464-1.159a15.494,15.494,0,0,1-.348-4.176c.267-1.171.591.035.9,1.439s.509,4.776,1.111,4.615,2.528-2.62,2.981-3.582-2.539-3.908-2.5-4.5,2.342.535,2.7,1.149a15.4,15.4,0,0,1,.706,1.427s1.438-.9,1.4-3.676-2.064-1.9-2.064-1.9",
    transform: "translate(46.247 13.866)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87905",
    "data-name": "Group 87905",
    transform: "translate(166.541 89.443)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87904",
    "data-name": "Group 87904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87903",
    "data-name": "Group 87903",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276646",
    "data-name": "Path 276646",
    d: "M137.547,82.222s-2.261,1.449-3.548-.21.871-4.7-1.031-5.995-5.183.684-5.183.684,2.528.741,2.447,2.122-1.3,1.9-1.462,1.3-1.367-3.641-3.42-2.378a5.085,5.085,0,0,0-2.366,3.223s4.778-.509,5.068,1.289-1.96-.314-3.931-.43-3.769.173-3.641,1.367a15.591,15.591,0,0,1-.187,3.154,5.868,5.868,0,0,1,3.839-1.356c2.168.128,2.086,1.508.115,1.391s-3.665,1.763-3.665,1.763a16.287,16.287,0,0,0,4.081,4.592c2.283,1.519,3.108.975,3.374-.2s-.346-4.174,1.033-4.093-2.285,5.205-.522,5.508,3.177-.208,3.641-1.367l.464-1.159a15.494,15.494,0,0,1-.348-4.176c.267-1.171.591.035.9,1.439s.509,4.776,1.111,4.615,2.528-2.62,2.981-3.582-2.539-3.908-2.5-4.5,2.342.535,2.7,1.149a15.4,15.4,0,0,1,.706,1.427s1.438-.9,1.4-3.676-2.064-1.9-2.064-1.9",
    transform: "translate(-120.293 -75.577)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276647",
    "data-name": "Path 276647",
    d: "M124.477,86.811a.249.249,0,0,1-.152-.055.236.236,0,0,1-.034-.338,28.567,28.567,0,0,1,5.525-5.518.24.24,0,0,1,.335.07.243.243,0,0,1-.07.333,28.214,28.214,0,0,0-5.418,5.418.238.238,0,0,1-.186.089",
    transform: "translate(47.852 16.016)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276648",
    "data-name": "Path 276648",
    d: "M123.262,87.186a.23.23,0,0,1-.139-.046.238.238,0,0,1-.055-.335s.38-.528,1-1.32a.241.241,0,0,1,.381.3c-.609.784-.99,1.3-.99,1.3a.238.238,0,0,1-.194.1",
    transform: "translate(47.358 17.86)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276649",
    "data-name": "Path 276649",
    d: "M131.645,87.949a.237.237,0,0,1-.236-.21,16.143,16.143,0,0,0-2.556-6.175.243.243,0,0,1,.4-.28,16.388,16.388,0,0,1,2.632,6.393.234.234,0,0,1-.205.267.079.079,0,0,1-.031,0",
    transform: "translate(49.713 16.148)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276650",
    "data-name": "Path 276650",
    d: "M127.668,86.552h-.015a.243.243,0,0,1-.225-.256c.155-2.6-.07-3.2-.148-3.329a.255.255,0,0,1-.2-.12.243.243,0,0,1,.09-.331.372.372,0,0,1,.349.015c.163.1.6.364.393,3.794a.238.238,0,0,1-.241.225",
    transform: "translate(48.995 16.676)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276651",
    "data-name": "Path 276651",
    d: "M128.424,81.325a.232.232,0,0,1-.179-.082.236.236,0,0,1,.02-.338,2.965,2.965,0,0,0,.521-3.08.24.24,0,0,1,.159-.3.237.237,0,0,1,.3.16,3.393,3.393,0,0,1-.66,3.576.231.231,0,0,1-.159.062",
    transform: "translate(49.458 14.656)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276652",
    "data-name": "Path 276652",
    d: "M127.479,82.168a.239.239,0,0,1-.21-.124l-.893-1.635a.238.238,0,0,1,.093-.326.245.245,0,0,1,.326.093l.893,1.635a.237.237,0,0,1-.093.326.259.259,0,0,1-.117.031",
    transform: "translate(48.71 15.689)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276653",
    "data-name": "Path 276653",
    d: "M127.219,83.533a.221.221,0,0,1-.144-.051c-.027-.02-2.8-2.1-4.485-2.2a.243.243,0,0,1-.225-.256.238.238,0,0,1,.241-.225h.015c1.825.108,4.624,2.209,4.741,2.3a.233.233,0,0,1,.046.333.238.238,0,0,1-.19.1",
    transform: "translate(47.09 15.993)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276654",
    "data-name": "Path 276654",
    d: "M141.989,76.562s-.09,3.251-2.628,3.41-4.108-4.073-6.705-3.054-2.849,5.656-2.849,5.656,2.466-2.026,3.793-1,1.017,2.6.3,2.348-4.578-1.113-4.712,1.8a6.152,6.152,0,0,0,1.614,4.565s2.746-5.129,4.744-4.2-1.65,1.749-3.111,3.644-2.394,3.891-1.113,4.578a18.855,18.855,0,0,1,3.032,2.335,7.112,7.112,0,0,1,1.258-4.768c1.607-2.084,2.933-1.061,1.473.833s-.734,4.871-.734,4.871a19.746,19.746,0,0,0,7.38-.955c3.077-1.252,3.094-2.448,2.1-3.513s-4.416-2.5-3.395-3.824,3.655,5.837,5.158,4.278,1.958-3.323,1.113-4.578l-.844-1.255s-3.426-1.432-4.416-2.5.438-.568,2.055.075,5.131,2.748,5.38,2.033-.9-4.318-1.556-5.426-5.643-.122-6.211-.56,2.131-1.981,2.991-1.922a18.507,18.507,0,0,1,1.911.264s.075-2.057-2.724-3.911-3.31.77-3.31.77",
    transform: "translate(49.865 13.685)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87908",
    "data-name": "Group 87908",
    transform: "translate(179.05 88.813)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87907",
    "data-name": "Group 87907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87906",
    "data-name": "Group 87906",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276655",
    "data-name": "Path 276655",
    d: "M141.989,76.562s-.09,3.251-2.628,3.41-4.108-4.073-6.705-3.054-2.849,5.656-2.849,5.656,2.466-2.026,3.793-1,1.017,2.6.3,2.348-4.578-1.113-4.712,1.8a6.152,6.152,0,0,0,1.614,4.565s2.746-5.129,4.744-4.2-1.65,1.749-3.111,3.644-2.394,3.891-1.113,4.578a18.855,18.855,0,0,1,3.032,2.335,7.112,7.112,0,0,1,1.258-4.768c1.607-2.084,2.933-1.061,1.473.833s-.734,4.871-.734,4.871a19.746,19.746,0,0,0,7.38-.955c3.077-1.252,3.094-2.448,2.1-3.513s-4.416-2.5-3.395-3.824,3.655,5.837,5.158,4.278,1.958-3.323,1.113-4.578l-.844-1.255s-3.426-1.432-4.416-2.5.438-.568,2.055.075,5.131,2.748,5.38,2.033-.9-4.318-1.556-5.426-5.643-.122-6.211-.56,2.131-1.981,2.991-1.922a18.507,18.507,0,0,1,1.911.264s.075-2.057-2.724-3.911-3.31.77-3.31.77",
    transform: "translate(-129.185 -75.129)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276656",
    "data-name": "Path 276656",
    d: "M137.93,90.428a.236.236,0,0,1-.229-.17c-.834-2.773-1.818-6.633-1.754-9.278a.24.24,0,0,1,.241-.236h0a.24.24,0,0,1,.238.245c-.062,2.582.909,6.391,1.732,9.129a.239.239,0,0,1-.159.3.245.245,0,0,1-.07.011",
    transform: "translate(52.615 15.968)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276657",
    "data-name": "Path 276657",
    d: "M138.36,90.6a.242.242,0,0,1-.225-.159s-.271-.741-.641-1.9a.243.243,0,0,1,.156-.3.24.24,0,0,1,.3.155c.366,1.145.633,1.88.633,1.884a.238.238,0,0,1-.144.307.21.21,0,0,1-.082.015",
    transform: "translate(53.242 19.015)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276658",
    "data-name": "Path 276658",
    d: "M145.038,82.444a.225.225,0,0,1-.108-.027,19.544,19.544,0,0,0-7.88-1.659h-.077a.241.241,0,0,1,0-.481,20.03,20.03,0,0,1,8.178,1.712.24.24,0,0,1-.108.454",
    transform: "translate(52.936 15.779)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276659",
    "data-name": "Path 276659",
    d: "M140.923,85.5a.235.235,0,0,1-.148-.051c-2.577-1.988-3.323-2.131-3.486-2.131h-.008a.229.229,0,0,1-.205.12h-.015a.244.244,0,0,1-.225-.256.374.374,0,0,1,.221-.3c.326-.12,1.095-.069,4.015,2.186a.243.243,0,0,1,.044.339.236.236,0,0,1-.191.093m-3.607-2.288v0Z",
    transform: "translate(52.977 16.826)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276660",
    "data-name": "Path 276660",
    d: "M136.088,81.325a.237.237,0,0,1-.236-.21,3.626,3.626,0,0,0-2.766-2.665.241.241,0,0,1-.155-.3.248.248,0,0,1,.3-.155,4.057,4.057,0,0,1,3.091,3.06.234.234,0,0,1-.205.267.079.079,0,0,1-.031,0",
    transform: "translate(51.385 14.846)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276661",
    "data-name": "Path 276661",
    d: "M136.407,82.677h-.024l-2.244-.221a.242.242,0,0,1,.024-.483h.023l2.245.222a.246.246,0,0,1,.217.263.243.243,0,0,1-.241.218",
    transform: "translate(51.792 16.469)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276662",
    "data-name": "Path 276662",
    d: "M132.2,87.845a.232.232,0,0,1-.148-.051.241.241,0,0,1-.042-.338c1.339-1.74,5.339-3.111,5.511-3.168a.255.255,0,0,1,.307.151.244.244,0,0,1-.152.307c-.039.013-4.031,1.379-5.286,3.006a.234.234,0,0,1-.19.093",
    transform: "translate(50.994 17.407)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276663",
    "data-name": "Path 276663",
    d: "M131.76,133.752h0a.485.485,0,0,1-.477-.485c.214-32.352-12.357-41.113-12.485-41.2a.481.481,0,0,1,.532-.8c.536.353,13.133,9.06,12.915,42a.482.482,0,0,1-.481.478",
    transform: "translate(45.551 20.218)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276664",
    "data-name": "Path 276664",
    d: "M134.782,90.365s-.411,3.744-3.354,3.686-4.357-5.086-7.449-4.156-3.821,6.256-3.821,6.256,3.037-2.1,4.471-.8.93,3.092.129,2.738-5.179-1.715-5.608,1.638a7.125,7.125,0,0,0,1.432,5.421s3.652-5.661,5.869-4.394-2.069,1.861-3.932,3.91-3.132,4.264-1.716,5.177a21.857,21.857,0,0,1,3.277,2.983,8.229,8.229,0,0,1,1.9-5.383c2.05-2.252,3.485-.948,1.621,1.1s-1.307,5.55-1.307,5.55,4.937.747,8.606-.407,3.8-2.531,2.759-3.855-4.861-3.3-3.555-4.733,3.666,7.081,5.547,5.423,2.573-3.649,1.716-5.177l-.855-1.528s-3.818-1.977-4.861-3.3.559-.615,2.365.28,5.661,3.654,6.016,2.853-.632-5.068-1.283-6.408-6.5-.674-7.115-1.232,2.646-2.085,3.634-1.936a21.452,21.452,0,0,1,2.179.485s.28-2.365-2.774-4.769-3.893.575-3.893.575",
    transform: "translate(45.757 19.268)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87911",
    "data-name": "Group 87911",
    transform: "translate(164.843 108.119)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87910",
    "data-name": "Group 87910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87909",
    "data-name": "Group 87909",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276665",
    "data-name": "Path 276665",
    d: "M134.782,90.365s-.411,3.744-3.354,3.686-4.357-5.086-7.449-4.156-3.821,6.256-3.821,6.256,3.037-2.1,4.471-.8.93,3.092.129,2.738-5.179-1.715-5.608,1.638a7.125,7.125,0,0,0,1.432,5.421s3.652-5.661,5.869-4.394-2.069,1.861-3.932,3.91-3.132,4.264-1.716,5.177a21.857,21.857,0,0,1,3.277,2.983,8.229,8.229,0,0,1,1.9-5.383c2.05-2.252,3.485-.948,1.621,1.1s-1.307,5.55-1.307,5.55,4.937.747,8.606-.407,3.8-2.531,2.759-3.855-4.861-3.3-3.555-4.733,3.666,7.081,5.547,5.423,2.573-3.649,1.716-5.177l-.855-1.528s-3.818-1.977-4.861-3.3.559-.615,2.365.28,5.661,3.654,6.016,2.853-.632-5.068-1.283-6.408-6.5-.674-7.115-1.232,2.646-2.085,3.634-1.936a21.452,21.452,0,0,1,2.179.485s.28-2.365-2.774-4.769-3.893.575-3.893.575",
    transform: "translate(-119.086 -88.851)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276666",
    "data-name": "Path 276666",
    d: "M128.526,106.315a.243.243,0,0,1-.236-.19c-.7-3.274-1.472-7.814-1.149-10.862a.245.245,0,0,1,.241-.212h.027a.246.246,0,0,1,.214.267c-.318,2.983.443,7.468,1.141,10.706a.246.246,0,0,1-.186.287c-.016,0-.035,0-.051,0",
    transform: "translate(49.003 21.789)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276667",
    "data-name": "Path 276667",
    d: "M128.987,106.56a.244.244,0,0,1-.234-.179c0-.007-.245-.9-.563-2.248a.236.236,0,0,1,.179-.287.23.23,0,0,1,.287.179c.319,1.339.56,2.22.564,2.233a.241.241,0,0,1-.172.294.312.312,0,0,1-.062.008",
    transform: "translate(49.458 25.365)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276668",
    "data-name": "Path 276668",
    d: "M137.457,97.773a.234.234,0,0,1-.125-.035c-3.739-2.306-8.983-2.663-9.036-2.667a.241.241,0,0,1,.017-.481h.014a22.924,22.924,0,0,1,9.253,2.738.234.234,0,0,1,.082.329.241.241,0,0,1-.2.117",
    transform: "translate(49.412 21.602)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276669",
    "data-name": "Path 276669",
    d: "M132.423,100.916a.239.239,0,0,1-.163-.062c-2.885-2.629-3.7-2.8-3.865-2.8h-.011a.217.217,0,0,1-.241.117.239.239,0,0,1-.2-.273.39.39,0,0,1,.256-.294c.214-.063.84-.335,4.388,2.893a.243.243,0,0,1,.017.342.247.247,0,0,1-.179.077m-4.008-2.947v0Z",
    transform: "translate(49.358 22.815)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276670",
    "data-name": "Path 276670",
    d: "M127.239,95.637a.242.242,0,0,1-.241-.229c0-.089-.152-2.213-2.963-3.367a.24.24,0,0,1,.186-.443c3.1,1.275,3.254,3.686,3.258,3.787a.245.245,0,0,1-.229.252Z",
    transform: "translate(47.711 20.378)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276671",
    "data-name": "Path 276671",
    d: "M127.478,97.229a.143.143,0,0,1-.042,0l-2.572-.466a.241.241,0,0,1-.194-.28.235.235,0,0,1,.28-.194l2.57.466a.241.241,0,0,1-.042.478",
    transform: "translate(48.027 22.289)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276672",
    "data-name": "Path 276672",
    d: "M122.219,102.649a.242.242,0,0,1-.163-.062.245.245,0,0,1-.015-.342c1.709-1.875,6.439-3.071,6.64-3.122a.251.251,0,0,1,.291.174.241.241,0,0,1-.174.291c-.046.011-4.792,1.211-6.4,2.983a.243.243,0,0,1-.179.077",
    transform: "translate(46.933 23.444)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276673",
    "data-name": "Path 276673",
    d: "M131.838,131a.481.481,0,0,1-.478-.439c-.846-9.087-8.931-15.366-9.012-15.428a.48.48,0,0,1-.09-.672.472.472,0,0,1,.672-.089,27.57,27.57,0,0,1,8.136,10.876l-1.46-26.235a.488.488,0,0,1,.454-.509h.027a.483.483,0,0,1,.481.454l1.752,31.532a.485.485,0,0,1-.446.509Z",
    transform: "translate(47.007 23.194)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276674",
    "data-name": "Path 276674",
    d: "M129.178,127.8a.484.484,0,0,1-.481-.481c0-.6.066-14.6,5.789-19.385a6.768,6.768,0,0,1,5.725-1.453.482.482,0,1,1-.172.948,5.748,5.748,0,0,0-4.935,1.242c-5.378,4.5-5.445,18.507-5.445,18.648a.484.484,0,0,1-.481.481",
    transform: "translate(49.667 26.39)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276675",
    "data-name": "Path 276675",
    d: "M130.425,135.082a.485.485,0,0,1-.478-.415c-.181-1.325-4.353-32.573,4.944-43.233a9.69,9.69,0,0,1,7.577-3.514.481.481,0,1,1,0,.962,8.783,8.783,0,0,0-6.851,3.181c-9.008,10.333-4.761,42.153-4.713,42.472a.484.484,0,0,1-.412.543c-.024,0-.046,0-.066,0",
    transform: "translate(49.733 18.888)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276676",
    "data-name": "Path 276676",
    d: "M136,107.533c-1.5-1.683-4.674-1.683-6.542,2.617s-.187,3.552-.187,3.552,3.551-1.121,5.795-1.87,5.234-2.617,5.421-1.5-1.5,2.244-3.552,2.617-7.476,1.87-6.916,2.991,1.87,4.487,1.87,4.487a47.638,47.638,0,0,1,5.046-3.738c2.431-1.5,3.927-.936,2.618.747s-5.048,3.552-4.3,5.795,5.234,5.048,5.234,5.048.56-4.674,1.87-6.169,1.308.187.934,2.8a30.408,30.408,0,0,0-.374,3.365l5.235,1.868a37.071,37.071,0,0,1,2.8-3.738l.934-.934s-4.112-3.552-4.3-5.795,2.8,0,3.738.373,2.431,2.991,2.431,2.991.934-4.3,1.121-5.795l.187-1.5s-3.927-1.5-5.421-1.5-2.244,1.123-2.244-.373,1.5-2.431,3.178-2.244a29.2,29.2,0,0,1,4.486,1.121s1.121-.934.747-3.738-1.308-2.8-3.551-2.057-3.739,2.431-5.422,2.431-.747-2.057.374-2.617,3.925-1.683,4.486-1.87-2.991-2.8-4.861-3.178-4.29.943-4.112,2.8c.374,3.925-5.234,4.674-6.729,2.991",
    transform: "translate(49.618 24.485)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276677",
    "data-name": "Path 276677",
    d: "M142.6,121.519a.242.242,0,0,1-.241-.229c-.024-.578-.062-1.141-.121-1.677a.246.246,0,0,1,.218-.265.259.259,0,0,1,.265.218c.053.543.1,1.118.12,1.7a.243.243,0,0,1-.229.252Z",
    transform: "translate(55.175 31.675)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276678",
    "data-name": "Path 276678",
    d: "M143.325,121.874a.24.24,0,0,1-.236-.2,49.8,49.8,0,0,0-3.5-11.525.245.245,0,0,1,.124-.318.251.251,0,0,1,.319.124,50.344,50.344,0,0,1,3.533,11.642.241.241,0,0,1-.2.276.139.139,0,0,1-.039,0",
    transform: "translate(54.089 27.795)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276679",
    "data-name": "Path 276679",
    d: "M139.8,111.45a.239.239,0,0,1-.218-.139c-.912-1.958-1.607-3.172-1.615-3.185a.266.266,0,0,1-.02-.194.263.263,0,0,1,.132-.148,5.307,5.307,0,0,0,2.314-2.131,6.365,6.365,0,0,1,1.95-2.334.23.23,0,0,1,.331.066.236.236,0,0,1-.066.331,6.076,6.076,0,0,0-1.787,2.155,5.569,5.569,0,0,1-2.31,2.236c.241.439.81,1.507,1.507,3a.237.237,0,0,1-.117.318.228.228,0,0,1-.1.024",
    transform: "translate(53.426 25.135)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276680",
    "data-name": "Path 276680",
    d: "M133.524,112.126a.24.24,0,0,1-.093-.461c2.9-1.213,6.45-2.572,6.927-2.268a.346.346,0,0,1,.136.248.252.252,0,0,1-.416.163h0a41.038,41.038,0,0,0-6.459,2.3.274.274,0,0,1-.093.02",
    transform: "translate(51.534 27.609)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276681",
    "data-name": "Path 276681",
    d: "M140.967,109.373a.24.24,0,0,1-.108-.454,15.071,15.071,0,0,1,5.716-1.522.241.241,0,1,1,0,.481,14.923,14.923,0,0,0-5.5,1.469.237.237,0,0,1-.108.027",
    transform: "translate(54.561 26.813)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276682",
    "data-name": "Path 276682",
    d: "M135.785,119.98a.21.21,0,0,1-.082-.015.238.238,0,0,1-.144-.307,16.142,16.142,0,0,1,2.652-4.373A26.955,26.955,0,0,1,141.8,111.7a.241.241,0,1,1,.3.381,25.716,25.716,0,0,0-3.514,3.519,16.006,16.006,0,0,0-2.575,4.225.242.242,0,0,1-.225.159",
    transform: "translate(52.453 28.542)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276683",
    "data-name": "Path 276683",
    d: "M147.612,113.5a.242.242,0,0,1-.163-.062c-1.937-1.76-5.72-.708-5.751-.691a.26.26,0,0,1-.3-.167.245.245,0,0,1,.166-.3c.167-.038,4.078-1.13,6.21.8a.241.241,0,0,1-.163.419",
    transform: "translate(54.832 28.662)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276684",
    "data-name": "Path 276684",
    d: "M153.582,98.9c-2.036-1.2-4.287-1.231-5.39-2.5s1.062-1.912,2.221-1.434,3.844,1.861,4.353,2.162.156-4.1-.786-5.753-3.524-2.621-4.814-1.268c-2.718,2.856-6.96-.889-6.67-3.12s-1.792-4.633-6.265-3.226-2.805,2.188-2.805,2.188,3.175,1.947,5.211,3.15,5.408,2.237,4.683,3.113-2.674.342-4.305-.967-6.313-4.42-6.792-3.261-2.162,4.353-2.162,4.353a47.463,47.463,0,0,1,6.131,1.36c2.722.854,3.279,2.351,1.152,2.466s-5.992-1.483-7.195.551-.38,7.261-.38,7.261,3.9-2.639,5.884-2.632.716,1.111-1.505,2.545a30.093,30.093,0,0,0-2.786,1.923l2.02,5.177a37.307,37.307,0,0,1,4.661-.333l1.318.093s-.014-5.433,1.557-7.046,1.839,2.117,2.169,3.068-.665,3.8-.665,3.8,3.859-2.112,5.111-2.952l1.251-.839s-1.443-3.945-2.424-5.075-2.317-.958-1.189-1.939,2.817-.464,3.777.929a29.123,29.123,0,0,1,2.095,4.124s1.441.234,3.313-1.887,1.259-2.826-.775-4.029m-17.691,5.983c-1.5-.748,2.057-2.244,2.057-2.244,1.308-.187-.561,2.991-2.057,2.244m2.518-6.979c-.637-.319,1.275-.957,1.275-.957,2.763.532-.637,1.276-1.275.957",
    transform: "translate(49.991 17.024)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276685",
    "data-name": "Path 276685",
    d: "M133.229,102.862a.241.241,0,0,1-.174-.077.236.236,0,0,1,.011-.338c.393-.373.792-.774,1.189-1.189a.261.261,0,0,1,.342-.008.247.247,0,0,1,.007.342c-.4.419-.808.827-1.211,1.2a.238.238,0,0,1-.163.066",
    transform: "translate(51.413 24.287)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276686",
    "data-name": "Path 276686",
    d: "M134.957,103.649a.241.241,0,0,1-.183-.4,49.5,49.5,0,0,0,6.4-10.2.251.251,0,0,1,.322-.113.241.241,0,0,1,.113.322,50.2,50.2,0,0,1-6.473,10.3.239.239,0,0,1-.183.086",
    transform: "translate(52.117 20.921)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276687",
    "data-name": "Path 276687",
    d: "M140.027,93.3a.3.3,0,0,1-.1-.02.245.245,0,0,1-.124-.318c.881-1.972,1.344-3.3,1.351-3.309a.231.231,0,0,1,.132-.144.269.269,0,0,1,.194,0,5.326,5.326,0,0,0,3.126.349,6.419,6.419,0,0,1,3.04-.058.242.242,0,0,1,.172.3.247.247,0,0,1-.3.17,5.934,5.934,0,0,0-2.8.058,5.639,5.639,0,0,1-3.2-.279c-.176.47-.606,1.6-1.275,3.106a.246.246,0,0,1-.221.144",
    transform: "translate(54.179 19.528)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276688",
    "data-name": "Path 276688",
    d: "M140.638,93.035a.247.247,0,0,1-.183-.082.277.277,0,0,1-.058-.187,41.037,41.037,0,0,0-5.976-3.369.24.24,0,0,1-.105-.324.229.229,0,0,1,.324-.1c2.815,1.394,6.186,3.181,6.255,3.744a.361.361,0,0,1-.1.263.248.248,0,0,1-.159.059m-.159-.423v0Z",
    transform: "translate(51.942 19.302)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276689",
    "data-name": "Path 276689",
    d: "M146.122,96.64a.241.241,0,0,1-.183-.082,14.771,14.771,0,0,0-4.717-3.192.24.24,0,1,1,.186-.443,15.058,15.058,0,0,1,4.9,3.317.25.25,0,0,1-.024.342.254.254,0,0,1-.159.058",
    transform: "translate(54.703 20.917)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276690",
    "data-name": "Path 276690",
    d: "M131.295,95.467a.241.241,0,0,1-.086-.466,16.252,16.252,0,0,1,5.045-.858c.19,0,.38,0,.563,0a26.1,26.1,0,0,1,4.5.362.241.241,0,0,1-.093.473,27.415,27.415,0,0,0-4.963-.349,15.926,15.926,0,0,0-4.88.827.236.236,0,0,1-.086.015",
    transform: "translate(50.626 21.419)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276691",
    "data-name": "Path 276691",
    d: "M142.3,101.332h0a.24.24,0,0,1-.236-.245c.058-2.61-3.216-4.781-3.25-4.8a.241.241,0,0,1,.263-.4c.144.094,3.53,2.334,3.468,5.212a.241.241,0,0,1-.241.236",
    transform: "translate(53.736 22.112)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276692",
    "data-name": "Path 276692",
    d: "M131.575,116.427c-1.638-.968-3.45-.989-4.337-2.012s.855-1.539,1.788-1.154,3.094,1.5,3.5,1.74.125-3.3-.633-4.63-2.836-2.109-3.873-1.02c-2.189,2.3-5.6-.715-5.369-2.511s-1.443-3.728-5.042-2.6-2.257,1.76-2.257,1.76,2.555,1.567,4.192,2.535,4.353,1.8,3.769,2.506-2.151.274-3.464-.778-5.08-3.557-5.467-2.625-1.739,3.5-1.739,3.5a38.509,38.509,0,0,1,4.934,1.095c2.19.688,2.639,1.894.926,1.985s-4.82-1.193-5.789.445-.305,5.844-.305,5.844,3.136-2.126,4.734-2.119.577.893-1.21,2.047a24.625,24.625,0,0,0-2.243,1.548l1.625,4.167a30.035,30.035,0,0,1,3.752-.269l1.061.076s-.011-4.374,1.254-5.671,1.479,1.705,1.745,2.47-.535,3.054-.535,3.054,3.1-1.7,4.112-2.376l1.007-.675a20.593,20.593,0,0,0-1.951-4.083c-.788-.909-1.864-.772-.955-1.56s2.265-.374,3.039.747a23.513,23.513,0,0,1,1.685,3.319s1.161.189,2.667-1.518,1.013-2.275-.625-3.244m-14.236,4.816c-1.2-.6,1.654-1.805,1.654-1.805,1.052-.151-.452,2.407-1.654,1.805m2.026-5.616c-.513-.256,1.026-.77,1.026-.77,2.223.428-.512,1.026-1.026.77",
    transform: "translate(42.951 25.393)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276693",
    "data-name": "Path 276693",
    d: "M115.21,119.68a.241.241,0,0,1-.174-.077.236.236,0,0,1,.011-.338c.357-.338.668-.649.951-.952a.239.239,0,0,1,.35.326c-.287.311-.606.629-.975.975a.246.246,0,0,1-.163.066",
    transform: "translate(44.082 31.223)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276694",
    "data-name": "Path 276694",
    d: "M116.6,120.312a.241.241,0,0,1-.183-.4,40.063,40.063,0,0,0,5.146-8.2.245.245,0,0,1,.322-.113.242.242,0,0,1,.113.322,40.54,40.54,0,0,1-5.215,8.3.239.239,0,0,1-.183.086",
    transform: "translate(44.648 28.517)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276695",
    "data-name": "Path 276695",
    d: "M120.681,111.982a.3.3,0,0,1-.1-.02.245.245,0,0,1-.124-.318c.706-1.584,1.083-2.649,1.087-2.656a.225.225,0,0,1,.131-.144.278.278,0,0,1,.194,0,4.148,4.148,0,0,0,2.482.276,5.193,5.193,0,0,1,2.473-.046.241.241,0,0,1,.172.3.251.251,0,0,1-.3.172,4.648,4.648,0,0,0-2.228.046,4.425,4.425,0,0,1-2.563-.207c-.152.4-.494,1.29-1.01,2.455a.246.246,0,0,1-.221.143",
    transform: "translate(46.308 27.396)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276696",
    "data-name": "Path 276696",
    d: "M121.169,111.772a.231.231,0,0,1-.183-.086.238.238,0,0,1-.058-.159,34.5,34.5,0,0,0-4.781-2.687.238.238,0,0,1-.106-.322.232.232,0,0,1,.324-.106c4.986,2.475,5.039,2.905,5.055,3.044a.329.329,0,0,1-.1.257.235.235,0,0,1-.155.058",
    transform: "translate(44.507 27.213)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276697",
    "data-name": "Path 276697",
    d: "M125.584,114.675a.241.241,0,0,1-.183-.082,11.84,11.84,0,0,0-3.777-2.559.24.24,0,1,1,.186-.443,12.213,12.213,0,0,1,3.958,2.684.249.249,0,0,1-.024.342.254.254,0,0,1-.159.058",
    transform: "translate(46.729 28.512)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276698",
    "data-name": "Path 276698",
    d: "M113.654,113.727a.241.241,0,0,1-.086-.466,13.06,13.06,0,0,1,4.074-.692,20.686,20.686,0,0,1,4.086.288.245.245,0,0,1,.19.283.249.249,0,0,1-.284.19,20.65,20.65,0,0,0-3.537-.283c-.144,0-.3,0-.447,0a12.8,12.8,0,0,0-3.91.66.236.236,0,0,1-.086.015",
    transform: "translate(43.448 28.915)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276699",
    "data-name": "Path 276699",
    d: "M122.509,118.45h0a.24.24,0,0,1-.236-.245c.046-2.078-2.568-3.81-2.594-3.825a.241.241,0,1,1,.265-.4c.117.077,2.866,1.9,2.811,4.237a.241.241,0,0,1-.241.236",
    transform: "translate(45.952 29.474)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276700",
    "data-name": "Path 276700",
    d: "M125.875,92.585s-2.057,1.5-3.365,0,.561-4.486-1.308-5.608-4.859.934-4.859.934,2.43.561,2.43,1.87-1.121,1.87-1.308,1.308-1.5-3.365-3.365-2.057a4.811,4.811,0,0,0-2.055,3.178s4.485-.747,4.859.936-1.868-.187-3.738-.187-3.552.373-3.365,1.5a14.717,14.717,0,0,1,0,2.991,5.556,5.556,0,0,1,3.552-1.5c2.055,0,2.055,1.308.187,1.308a5.1,5.1,0,0,0-3.365,1.868,15.426,15.426,0,0,0,4.112,4.114c2.243,1.308,2.991.747,3.178-.374s-.561-3.925.747-3.925-1.868,5.046-.187,5.234,2.991-.374,3.365-1.5l.374-1.121a14.666,14.666,0,0,1-.561-3.925c.187-1.123.561,0,.936,1.308s.747,4.485,1.308,4.3,2.243-2.618,2.617-3.552-2.617-3.551-2.617-4.112,2.243.374,2.617.934a14.408,14.408,0,0,1,.747,1.308s1.308-.934,1.123-3.551-2.057-1.683-2.057-1.683",
    transform: "translate(41.972 18.369)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276701",
    "data-name": "Path 276701",
    d: "M113.846,97.577a.23.23,0,0,1-.139-.046.238.238,0,0,1-.055-.335,27.143,27.143,0,0,1,4.916-5.525.242.242,0,1,1,.288.388,26.765,26.765,0,0,0-4.816,5.416.238.238,0,0,1-.194.1",
    transform: "translate(43.527 20.395)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276702",
    "data-name": "Path 276702",
    d: "M112.788,97.929a.221.221,0,0,1-.128-.039.235.235,0,0,1-.075-.329s.331-.525.871-1.306a.237.237,0,0,1,.333-.062.242.242,0,0,1,.062.335c-.532.772-.858,1.289-.861,1.289a.238.238,0,0,1-.2.113",
    transform: "translate(43.096 22.237)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276703",
    "data-name": "Path 276703",
    d: "M120.774,98.166a.243.243,0,0,1-.236-.2,15.438,15.438,0,0,0-2.753-5.685.24.24,0,0,1,.034-.338.249.249,0,0,1,.339.035,15.561,15.561,0,0,1,2.853,5.9.239.239,0,0,1-.194.279.13.13,0,0,1-.042,0",
    transform: "translate(45.205 20.505)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276704",
    "data-name": "Path 276704",
    d: "M116.935,97.066a.243.243,0,0,1-.242-.241c0-2.427-.236-3-.318-3.122a.242.242,0,0,1-.132-.443.35.35,0,0,1,.342,0c.163.086.591.315.591,3.569a.242.242,0,0,1-.241.241",
    transform: "translate(44.556 21.042)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276705",
    "data-name": "Path 276705",
    d: "M117.306,92.094a.241.241,0,0,1-.17-.412,2.767,2.767,0,0,0,.318-2.923.239.239,0,1,1,.45-.163,3.234,3.234,0,0,1-.428,3.429.241.241,0,0,1-.17.07",
    transform: "translate(44.934 19.099)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276706",
    "data-name": "Path 276706",
    d: "M116.513,92.938a.233.233,0,0,1-.2-.113l-.936-1.5A.235.235,0,0,1,115.45,91a.229.229,0,0,1,.329.073l.937,1.5a.235.235,0,0,1-.075.329.221.221,0,0,1-.128.039",
    transform: "translate(44.231 20.125)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276707",
    "data-name": "Path 276707",
    d: "M116.342,94.241a.224.224,0,0,1-.132-.039c-.027-.018-2.764-1.829-4.353-1.829a.241.241,0,1,1,0-.481c1.736,0,4.5,1.829,4.617,1.906a.246.246,0,0,1,.07.335.249.249,0,0,1-.2.108",
    transform: "translate(42.717 20.505)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25552",
    "data-name": "Rectangle 25552",
    width: 14.451,
    height: 20.801,
    transform: "translate(172.275 152.834)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276708",
    "data-name": "Path 276708",
    d: "M138.957,142.058H124.509a.485.485,0,0,1-.483-.481v-20.8a.484.484,0,0,1,.483-.481h14.449a.484.484,0,0,1,.483.481v20.8a.485.485,0,0,1-.483.481m-13.967-.964h13.486v-19.84H124.99Z",
    transform: "translate(47.766 32.06)",
    fill: "#515255"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Ta);
export default __webpack_public_path__ + "static/media/2_TA.0ddcb24e8df050e1d4201fac526e137a.svg";
export { ForwardRef as ReactComponent };